// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-12T21:07:50.302Z
// Property: Pierpont (ID: 6767906449167362)
// Collections: 17 amenities, 2 floorplans (live), 45 photos, 38 POIs, 1 reviews, 6 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162458",
  "multihub_property_id": "6767906449167362",
  "property_external_id": "4962893",
  "property_zillow_url": "https://www.zillow.com/apartments/westerville-oh/pierpont-apartments/5XtGhz/",
  "property_apartments_url": "https://www.apartments.com/pierpont-apartments-westerville-oh/gct8c9y/",
  "property_google_business_url": "https://www.google.com/maps/place/Pierpont+Apartments/data=!4m2!3m1!1s0x0:0x64b44b55ea683af5?sa=X&ved=1t:2428&ictx=111",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": "4962893",
  "property_status": null,
  "property_slug": "pierpont",
  "property_name": "Pierpont",
  "property_website_url": "https://www.pierpontliving.com/",
  "property_domain": "https://www.pierpontliving.com/",
  "property_address": "8200 Worthington Galena Rd",
  "property_full_address": "8200 Worthington Galena Rd, Westerville, OH 43081",
  "property_address_1": "8200 Worthington Galena Rd",
  "property_address_2": null,
  "property_address_city": "Westerville",
  "property_address_state": "OH",
  "property_address_zip_full": "43081-5413",
  "property_address_zip": "43081",
  "property_address_country": "US",
  "property_address_county": "Franklin County",
  "property_neighborhood_address": "Far North",
  "property_address_latitude": "40.1300367",
  "property_address_longitude": "-82.9740135",
  "property_email": "pie@dietzpropertygroup.com",
  "property_phone": "(614) 848-9933",
  "property_call_tracking_phone": "614-860-5349",
  "property_company_name": "Dietz Property Group",
  "property_company_url": "https://dietzpropertygroup.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At Pierpont in Westerville, OH, stylish one- and two-bedroom apartments await your personal touch. Enjoy exceptional amenities, from a sparkling pool and clubhouse to fitness facilities and pet-friendly spaces. Experience the perfect blend of comfort and convenience. Ready to make Pierpont your home? Check our availability or schedule a tour today!",
  "property_long_description": "Welcome to Pierpont, the perfect apartment community nestled in the heart of Westerville, OH! Our thoughtfully designed one and two-bedroom floor plans cater to diverse lifestyles and provide a welcoming sanctuary for you to call home. Each apartment boasts modern amenities, including stylish stainless steel appliances, air conditioning, and convenient in-unit washer/dryer pairs, ensuring your comfort and convenience are well met.\n\nAt Pierpont, we pride ourselves on fostering a vibrant community atmosphere. Enjoy sunny afternoons at our refreshing pool, or gather with friends and family in our inviting picnic and grill areas. For pet owners, our pet-friendly policy means your furry friends are just as welcome as you are! Stay active with our fully-equipped fitness center, and unwind in our cozy clubhouse—a perfect spot to socialize or relax.\n\nOur professional management team is dedicated to providing exceptional service, with flexible rent payment options that make managing your finances easier. With central heating, fire protection systems for safety, and recent flood renovations—completed in 2016 and 2017—you’ll enjoy peace of mind while living in style.\n\nLocated in an ideal area, Pierpont offers easy access to shopping, dining, and recreational activities, making it the ultimate spot to enjoy life in Westerville. Don't wait—find your new home today by browsing our availability or scheduling a tour to visit our community. Experience the Pierpont lifestyle and make memories that last a lifetime!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019dbc46-4c58-704e-8ffc-b040e3e3a77a.webp",
  "property_featured_image_media": {
    "alt_text": "Living room and kitchen area with a sofa, coffee table, TV, and bar stools.",
    "public_id": "019dbc46-4c58-704e-8ffc-b040e3e3a77a",
    "storage_key": "property/6767906449167362/019dbc46-4c58-704e-8ffc-b040e3e3a77a.webp"
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "212",
  "property_year_built": "1987",
  "property_year_renovated": null,
  "property_walk_score": "28",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "89.62264150943396",
  "property_admin_fee": "150",
  "property_application_fee": "50",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "200",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "35",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Limit of 2 pets per household. Breed restrictions apply.",
  "property_pet_policy_description": "We allow Cats and Dogs. Limit of 2 pets per household. There is a $200 pet fee per pet and $35/mo pet rent per month. Breed restrictions apply.",
  "property_petpolicy_info": "Pet Policy Type: Cat, Dogs\nPet Policy: We allow Cats and Dogs. Limit of 2 pets per household. There is a $200 pet fee per pet and $35/mo pet rent per month. Breed restrictions apply.",
  "property_online_leasing_url": "https://oll-leasing.loftliving.com/oll/?siteId=4962893",
  "property_resident_portal_url": "https://pierpontapartments.loftliving.com/login",
  "property_apply_now_url": null,
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63bb-2b8f-7464-808a-f50a7b4ccac4.webp",
  "property_primary_logo_media": {
    "alt_text": "Pierpont Apartments logo with a stylized A.",
    "public_id": "019d63bb-2b8f-7464-808a-f50a7b4ccac4",
    "storage_key": "property/6767906449167362/019d63bb-2b8f-7464-808a-f50a7b4ccac4.webp"
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019dbbbc-2515-7365-856a-2b876eda176d.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019dbbbc-2515-7365-856a-2b876eda176d",
    "storage_key": "property/6767906449167362/019dbbbc-2515-7365-856a-2b876eda176d.webp"
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019dbbbc-1af6-725d-a10a-a9d013b6b67d.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019dbbbc-1af6-725d-a10a-a9d013b6b67d",
    "storage_key": "property/6767906449167362/019dbbbc-1af6-725d-a10a-a9d013b6b67d.webp"
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162458/019dffdc-8ac5-716c-b71f-1f453648e537.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162458/019d638a-0da7-727f-ad43-3bd78629f61b.webp",
  "property_company_logo_media": {
    "alt_text": "Dietz Property Group logo",
    "public_id": "019d638a-0da7-727f-ad43-3bd78629f61b",
    "storage_key": "company/5767906449162458/019d638a-0da7-727f-ad43-3bd78629f61b.webp"
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162458/019e28a2-379b-72ca-a5a9-1262d569a77e.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "DPG logo",
    "public_id": "019e28a2-379b-72ca-a5a9-1262d569a77e",
    "storage_key": "company/5767906449162458/019e28a2-379b-72ca-a5a9-1262d569a77e.webp"
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162458/019e28a2-7e6e-752b-a7e2-54f21a5cd171.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "DPG logo in white on black background.",
    "public_id": "019e28a2-7e6e-752b-a7e2-54f21a5cd171",
    "storage_key": "company/5767906449162458/019e28a2-7e6e-752b-a7e2-54f21a5cd171.webp"
  },
  "property_primary_color": "#0AB38A",
  "property_secondary_color": "#ffffff",
  "property_font_color": "#000000",
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 1",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "1",
  "property_sqft_range": "600 - 800",
  "property_sqft_min": "600",
  "property_sqft_max": "800",
  "property_price_range": "1139 - 1299",
  "property_price_min": "1139",
  "property_price_max": "1299",
  "property_available_units": 22,
  "property_facebook_url": "https://www.facebook.com/PierpontApartmentsOH",
  "property_instagram_url": null,
  "property_twitter_url": "https://x.com/pierpontaptsoh",
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJk4IFi4z0OIgR9Tpo6lVLtGQ",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/pierpont-apartments-westerville",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Pierpont",
  "property_home_romance_title": "Embrace Comfort and Connection in Your New Apartment Home",
  "property_home_amenities_blurb": "Welcome to Pierpont in Westerville, OH, where comfort meets style. Choose from spacious one- or two-bedroom floor plans and enjoy our inviting pool, fitness center, and pet-friendly picnic area. With modern amenities like stainless steel appliances and flexible rent options, your perfect home awaits just around the corner!",
  "property_home_floorplans_blurb": "At Pierpont in Westerville, OH, we offer thoughtfully designed one and two-bedroom apartments that blend comfort and style. With spacious layouts and modern amenities, your ideal living space awaits. Browse our available apartment homes and choose the perfect floor plan that suits your lifestyle today!",
  "property_home_gallery_blurb": "Welcome to Pierpont in Westerville, OH, where your ideal lifestyle meets modern luxury. Choose from spacious one or two-bedroom floor plans, all featuring upscale amenities like a refreshing pool, pet-friendly spaces, and a state-of-the-art fitness center. Picture yourself enjoying sunny picnics or cozy evenings in our inviting clubhouse!",
  "property_home_neighborhood_blurb": "At Pierpont in Westerville, you’ll appreciate not just your stylish one or two-bedroom apartment, but also the vibrant community around you. Enjoy the serenity of Alum Creek Park, the creativity of the McConnell Arts Center, or the history at the Westerville History Museum—all just moments away from your new home.",
  "property_home_reviews_blurb": "Welcome to Pierpont, your peaceful retreat in Westerville, OH! Our residents rave about the strong sense of community and tranquility: \"I have no complaints! Love my neighbors and the upkeep.\" Enjoy affordable living, convenient amenities, and a dedicated maintenance team. Discover why Pierpont is a great place to call home!",
  "property_neighborhood_blurb": "Nestled in vibrant Westerville, Pierpont offers access to dynamic educational institutions like Otterbein University and top-notch parks like Alum Creek. Unwind at the charming Westerville History Museum or dive into adventure at Zoombezi Bay. Dive into the neighborhood’s rich offerings—an array of local favorites awaits just steps from your door!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Pierpont in Westerville, OH, elevate your lifestyle with our spacious one and two-bedroom apartments. Relax by the pool, enjoy picnics in our vibrant outdoor areas, and stay active at our fitness center. Pet-friendly and perfectly located, Pierpont offers everything you need for modern living. Experience home like never before!",
  "property_applynow_blurb": "Welcome to Pierpont in Westerville, OH, where comfort meets convenience. Choose from spacious one- and two-bedroom floor plans with modern amenities like stainless steel appliances and a state-of-the-art fitness center. Enjoy sunny days by the pool or gather with friends at our picnic and grill area. Lease online today and make Pierpont your new home!",
  "property_contactus_blurb": "At Pierpont in Westerville, OH, our thoughtfully designed one and two-bedroom floor plans offer the perfect blend of comfort and style. Whether you’re seeking a cozy retreat or more space to live freely, our community has something for everyone. Have questions? Contact our leasing team today!",
  "property_faqs_blurb": "At Pierpont in Westerville, OH, find the perfect floor plan for your lifestyle, whether it’s a cozy one-bedroom or a spacious two-bedroom. Curious about our community? Dive into our FAQs page to uncover the details that make Pierpont the ideal place to call home. Your answers await!",
  "property_floorplans_blurb": "At Pierpont in Westerville, OH, we offer thoughtfully designed one and two-bedroom apartments that effortlessly blend comfort and style. Each floor plan maximizes space to suit your lifestyle. Browse our available options and find the perfect apartment home that elevates your living experience today.",
  "property_gallery_blurb": "At Pierpont in Westerville, OH, vibrant living meets modern comfort. Choose from spacious one or two-bedroom floor plans, each featuring stainless steel appliances and air conditioning. Dive into relaxation at our pool, enjoy a picnic with friends, or break a sweat in the fitness center. Picture yourself living here!",
  "property_interactivemap_blurb": "At Pierpont in Westerville, OH, your ideal home awaits. Choose from spacious one and two-bedroom floor plans, and enjoy amenities like a sparkling pool, fitness center, and picnic area. With pet-friendly policies and flexible rent options, explore your future oasis using our interactive community map today!",
  "property_pets_blurb": "Welcome to Pierpont in Westerville, OH, where modern living meets pet-friendly convenience! Enjoy spacious homes alongside your furry friends with a limit of two pets per household. With a cozy community atmosphere, your perfect retreat awaits—complete with the comfort your pets deserve and unique local charm at your doorstep.",
  "property_referafriend_blurb": "At Pierpont in Westerville, OH, we celebrate community connections. With spacious one- and two-bedroom floor plans, your perfect apartment awaits. Invite a friend to join you in this welcoming environment—because great friends make great neighbors! Share the love and refer someone special to call Pierpont home today!",
  "property_residentaccess_blurb": "Welcome to Pierpont, your ideal Westerville retreat! Our thoughtfully designed floor plans feature spacious one and two-bedroom apartments tailored for comfort and style. Access your resident portal effortlessly to pay rent, schedule maintenance, and stay connected with our vibrant community—right at your fingertips!",
  "property_reviews_blurb": "At Pierpont in Westerville, OH, residents appreciate the convenience and warmth of community life. One resident notes, \"I have no complaints! Love my neighbors and the community.\" With ample parking, a refreshing pool, and quick maintenance responses, Pierpont is an affordable haven for those seeking comfort and tranquility. See what our residents have to say about living at our community!",
  "property_created_at": "1775494426131",
  "property_scheduletour_blurb": "At Pierpont in Westerville, OH, our thoughtfully designed one and two-bedroom apartments offer a perfect blend of comfort and style. Uncover the unique features of each floor plan, and imagine your life here. Schedule a tour today and hear directly from our residents about the vibrant community waiting for you!",
  "property_thankyou_blurb": "Thank you for reaching out to Pierpont in vibrant Westerville, OH! With thoughtfully designed one and two-bedroom floor plans, our community offers the perfect blend of comfort and style. Stay tuned—someone from our team will be in touch soon to help you find your ideal apartment home!",
  "property_virtualtours_blurb": "At Pierpont in Westerville, OH, find your perfect sanctuary with our thoughtfully designed one- and two-bedroom apartments. Each space offers modern comfort and style, inviting you to come home. Ready to experience life at Pierpont? Take a virtual tour today and envision your new beginning!",
  "property_copyright": "2026 All Rights Reserved. Pierpont",
  "property_seo_title_home": "Pierpont |  Apartments in Westerville, OH",
  "property_seo_description_home": "Elevate your lifestyle at Pierpont in Westerville! Enjoy spacious one & two-bedroom apartments with premium amenities. Find your new home today!",
  "property_seo_title_floorplans": "Floor Plans | Westerville, OH Apartments for Rent",
  "property_seo_description_floorplans": "Find your perfect home at Pierpont in Westerville, OH! Choose from stylish one and two-bedroom layouts designed for comfort and convenience. Browse today!",
  "property_seo_title_amenities": "Amenities | Westerville, OH Apartments for Rent",
  "property_seo_description_amenities": "Discover vibrant living at Pierpont in Westerville, OH! Enjoy a pool, pet-friendly spaces, and modern apartments. Your new home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Westerville, OH",
  "property_seo_description_gallery": "Discover life at Pierpont in Westerville, OH! Enjoy top amenities like a pool, gym, and pet-friendly areas. Explore your future home in our gallery!",
  "property_seo_title_virtualtours": "Virtual Tours | Pierpont Apartments",
  "property_seo_description_virtualtours": "Experience the charm of Pierpont in Westerville, OH! Take a virtual tour of our stylish one and two-bedroom apartments today—your new home awaits!",
  "property_seo_title_interactivemap": "Interactive Map | Pierpont Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Pierpont in Westerville, OH! With one and two-bedroom options, a pool, fitness center, and pet-friendly amenities, your dream awaits!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Westerville, OH",
  "property_seo_description_neighborhood": "Uncover Westerville's charm at Pierpont! From vibrant local spots to serene parks, dive into the neighborhood that makes this community truly special.",
  "property_seo_title_contact": "Contact Us | Pierpont",
  "property_seo_description_contact": "Connect with Pierpont in Westerville, OH! Inquire about our one and two-bedroom floor plans and let our leasing team assist you. Your new home awaits!",
  "property_seo_title_faqs": "FAQs | Apartments in Westerville, OH",
  "property_seo_description_faqs": "Find answers to your queries about Pierpont in Westerville, OH. From floor plans to amenities, browse our FAQs for clarity and peace of mind.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Westerville, OH",
  "property_seo_description_reviews": "Discover vibrant living at Pierpont in Westerville, OH! Enjoy spacious floor plans, great amenities, and a pet-friendly community. Join us!",
  "property_seo_title_applynow": "Apply Now | Apartments in Westerville, OH",
  "property_seo_description_applynow": "Discover Pierpont in Westerville, OH! Enjoy spacious one or two-bedroom homes, premium amenities, and pet-friendly living. Apply today!",
  "property_seo_title_residentaccess": "Resident Access | Pierpont",
  "property_seo_description_residentaccess": "Unlock convenience at Pierpont in Westerville, OH! Log in to your resident portal for easy rent payments, maintenance requests, and community updates.",
  "property_seo_title_referafriend": "Refer A Friend | Pierpont",
  "property_seo_description_referafriend": "Invite your friends to experience life at Pierpont in Westerville, OH! Great friends make great neighbors—refer someone special today and enjoy the perks!",
  "property_seo_title_scheduletour": "Schedule a Tour | Pierpont",
  "property_seo_description_scheduletour": "Experience life at Pierpont in Westerville, OH. Schedule a tour today and see vibrant living spaces and exceptional amenities that elevate your lifestyle!",
  "property_seo_title_privacy": "Privacy Policy | Pierpont",
  "property_seo_description_privacy": "Your privacy matters! At Pierpont in Westerville, OH, learn how we protect your personal information. Click to view our privacy policy and stay informed.",
  "property_seo_title_accessibility": "Website Accessibility | Pierpont",
  "property_seo_description_accessibility": "Experience accessibility at Pierpont in Westerville, OH. We’re committed to digital inclusion, ensuring everyone can explore our vibrant community with ease.",
  "property_seo_title_sitemap": "Sitemap | Pierpont",
  "property_seo_description_sitemap": "Navigate your way to Pierpont in Westerville, OH! Our sitemap helps you find every detail of your future home. Connect with us today for an easy start!",
  "property_seo_title_thankyou": "Thank You | Pierpont",
  "property_seo_description_thankyou": "Thank you for your interest in Pierpont! Expect to hear from us soon about your ideal Westerville apartment and how we can make it your perfect home!",
  "property_seo_title_pets": "Pet Policy | Apartments in Westerville, OH",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1785766126074",
  "amenities": [
    {
      "id": "custom_22c3c264-8fa0-4cec-a627-4d14c96ce4ff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "external_id": "P000000128",
      "title": "Pool",
      "amount": "0.0000",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_59745504-11d1-4404-b17c-f3cdb155fe76",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "external_id": "P000000211",
      "title": "Picnic Area",
      "amount": "0.0000",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8f996c31-d807-4470-bdda-ddd74161e3ed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "external_id": "P000000251",
      "title": "Grill Area",
      "amount": "0.0000",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9b79288f-82f0-495a-9668-3f81ffa016ee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "external_id": "P000000338",
      "title": "Pet Friendly",
      "amount": "0.0000",
      "description": "Pet Friendly",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_56abc074-1306-4b8e-a680-be2a72e061a1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "external_id": "P000000617",
      "title": "Professional Management",
      "amount": "0.0000",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_94d53a9a-5478-481b-9f01-e2b3984131b5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "external_id": "P000000618",
      "title": "Flexible Rent Payments",
      "amount": "0.0000",
      "description": "Pay Rent Your Way With Flex",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2f1c0245-0614-4c96-ab79-58bcfdf75274",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "external_id": "P000000619",
      "title": "Ideal Location",
      "amount": "0.0000",
      "description": "Nearby Shopping and Entertainment",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9c9db002-83d7-4011-a48f-759e79582060",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "external_id": "S100000019",
      "title": "Clubhouse",
      "amount": "0.0000",
      "description": "Clubhouse",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e3f424fe-46b4-46ed-ae91-1b04c184cbe1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "external_id": "S100000029",
      "title": "Fitness center",
      "amount": "0.0000",
      "description": "Fitness center with some weights and  exercise equipment",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ab4b7b16-5d1a-4856-9ddc-04ddad979628",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "external_id": "P000000062",
      "title": "Modern, Efficient, and Personalized Climate Control",
      "amount": "0.0000",
      "description": "Modern, Efficient, and Personalized Climate Control",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_183d4b72-3559-4cff-8ba3-1526b8444ea1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "external_id": "P000000177",
      "title": "Window Coverings",
      "amount": "0.0000",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c95e7050-4f46-4ce9-a2c9-ff3b7343aa5e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "external_id": "P000000186",
      "title": "Disposal",
      "amount": "0.0000",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0857ab92-37a4-4083-be15-f15199e1ff96",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "external_id": "P000000253",
      "title": "Stove",
      "amount": "0.0000",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7055e1b3-a4b2-402c-a3b7-b1951f037280",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "external_id": "P000000558",
      "title": "Stainless Steel Appliances",
      "amount": "0.0000",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_71bb8904-23bf-4e1a-8b83-279a19c8aa1e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "external_id": "P000000600",
      "title": "Full-Size Washer/Dryer in Every Apartment",
      "amount": "0.0000",
      "description": "Full-Size Washer/Dryer in Every Apartment",
      "group": "Apartment",
      "is_featured": "1",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8f8924c8-40dd-4ed3-8814-1b7f7ff7045d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "external_id": "S100000159",
      "title": "Refrigerator",
      "amount": "0.0000",
      "description": "Side-by-side refrigerator with no ice dispenser",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e21e46a5-dde5-40e8-9939-9ea1a01af1ba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "external_id": "S100000264",
      "title": "Dishwasher",
      "amount": "0.0000",
      "description": "Dishwasher",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_ed096c4d-bf79-477a-afc4-c43258a71dfe",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63bb-07ab-759a-aaea-6ffe0cea4fcd.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and a breakfast bar with stools at Pierpont Apartments in Westerville, Ohio.",
        "public_id": "019d63bb-07ab-759a-aaea-6ffe0cea4fcd",
        "storage_key": "property/6767906449167362/019d63bb-07ab-759a-aaea-6ffe0cea4fcd.webp"
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this beautifully appointed kitchen, featuring granite countertops, stainless steel appliances, and ample cabinet space. Perfect for casual dining or entertaining guests.",
      "link": "",
      "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and a breakfast bar with stools at Pierpont Apartments in Westerville, Ohio.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/T8dhgBHUqBse0LFrVrOZPNpys5BlsNeQSlSjUr2mQro/102/image.jpg"
    },
    {
      "id": "custom_1bbaf443-d86f-45e1-9981-17a2b602cb1f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63bb-295d-72ad-873c-8d991107fcb9.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and a breakfast bar at Pierpont Apartments in Westerville, Ohio.",
        "public_id": "019d63bb-295d-72ad-873c-8d991107fcb9",
        "storage_key": "property/6767906449167362/019d63bb-295d-72ad-873c-8d991107fcb9.webp"
      },
      "title": "Apartment",
      "description": "Step into this beautifully appointed apartment kitchen, featuring elegant granite countertops, modern stainless steel appliances, and a convenient breakfast bar perfect for casual dining.",
      "link": "",
      "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and a breakfast bar at Pierpont Apartments in Westerville, Ohio.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/2WXyevqeqN-bytnEoLr7G8V7NHN79i4_0WGU9eVPxPA/102/image.jpg"
    },
    {
      "id": "custom_ba1e0956-1159-489a-be1f-d9e962c2d257",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63bb-1456-76cc-9acc-a95b50176a03.webp",
      "image_media": {
        "alt_text": "Modern living room and kitchen area with a sofa, coffee table, and breakfast bar at Pierpont Apartments in Westerville, Ohio.",
        "public_id": "019d63bb-1456-76cc-9acc-a95b50176a03",
        "storage_key": "property/6767906449167362/019d63bb-1456-76cc-9acc-a95b50176a03.webp"
      },
      "title": "Apartment",
      "description": "Spacious open-concept living area featuring a comfortable sofa, modern kitchen with stainless steel appliances, and a dining nook. Perfect for entertaining.",
      "link": "",
      "alt_text": "Modern living room and kitchen area with a sofa, coffee table, and breakfast bar at Pierpont Apartments in Westerville, Ohio.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/gk3T0E02IHnGM2KY0IgAelniJyW1GPJ7AHFX5jfrqYg/102/image.jpg"
    },
    {
      "id": "custom_af45a9f2-81de-4d6e-9d3e-525c5e59504c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63bb-095c-757e-8f75-0090b4353406.webp",
      "image_media": {
        "alt_text": "Cozy living room with a dark gray sofa, coffee table, and a kitchen area in the background at Pierpont Apartments in Westerville, Ohio.",
        "public_id": "019d63bb-095c-757e-8f75-0090b4353406",
        "storage_key": "property/6767906449167362/019d63bb-095c-757e-8f75-0090b4353406.webp"
      },
      "title": "Apartment",
      "description": "Relax in style in this comfortable living room, complete with a plush sofa and modern decor. The open-concept design flows seamlessly into a fully-equipped kitchen.",
      "link": "",
      "alt_text": "Cozy living room with a dark gray sofa, coffee table, and a kitchen area in the background at Pierpont Apartments in Westerville, Ohio.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/5oB6-Cn_dT2VAmGNyaVrjPFk2PzdH5K8_n1GrPpK1yA/102/image.jpg"
    },
    {
      "id": "custom_dd412b1e-33a6-4fef-8e21-3d66c66bd975",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63bb-22d3-7613-9bc6-ec05376018fa.webp",
      "image_media": {
        "alt_text": "Living room with a dark gray sofa, a white coffee table, and a modern floor lamp at Pierpont Apartments in Westerville, Ohio.",
        "public_id": "019d63bb-22d3-7613-9bc6-ec05376018fa",
        "storage_key": "property/6767906449167362/019d63bb-22d3-7613-9bc6-ec05376018fa.webp"
      },
      "title": "Apartment",
      "description": "Relax in this cozy living room featuring a comfortable sofa, stylish decor, and ample natural light. Perfect for unwinding after a long day.",
      "link": "",
      "alt_text": "Living room with a dark gray sofa, a white coffee table, and a modern floor lamp at Pierpont Apartments in Westerville, Ohio.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/UK6NgmvxcvJLU-I8RAHHg0TgEfTo4XULDtybDGRDtbI/119/image.jpg"
    },
    {
      "id": "custom_8b645022-152f-47a2-9255-b86a2417849d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63bb-2099-73b8-8ab5-ebcb0bdbd73f.webp",
      "image_media": {
        "alt_text": "Dining area with a small table and chairs next to a closet at Pierpont Apartments in Westerville, Ohio.",
        "public_id": "019d63bb-2099-73b8-8ab5-ebcb0bdbd73f",
        "storage_key": "property/6767906449167362/019d63bb-2099-73b8-8ab5-ebcb0bdbd73f.webp"
      },
      "title": "Apartment",
      "description": "Enjoy a meal in the cozy dining area, complete with a modern table and chairs. Plenty of storage is available in the nearby closet.",
      "link": "",
      "alt_text": "Dining area with a small table and chairs next to a closet at Pierpont Apartments in Westerville, Ohio.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/o8GUsV2msy2pX42e0AmH3kLAujD1ARfL_d9ofOuLg-s/119/image.jpg"
    },
    {
      "id": "custom_9d192bdd-42cf-45ab-804d-6867fc1ee1a9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63bb-2391-77ba-a369-757ec8a42c21.webp",
      "image_media": {
        "alt_text": "A modern living room with a plaid armchair, a white media console with a TV, and a white front door at Pierpont Apartments in Westerville, Ohio.",
        "public_id": "019d63bb-2391-77ba-a369-757ec8a42c21",
        "storage_key": "property/6767906449167362/019d63bb-2391-77ba-a369-757ec8a42c21.webp"
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this well-appointed living space, featuring a cozy armchair and a sleek media console perfect for relaxation.",
      "link": "",
      "alt_text": "A modern living room with a plaid armchair, a white media console with a TV, and a white front door at Pierpont Apartments in Westerville, Ohio.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/vXNQGKC5iw0DWVm4647HBP3Fn2atKKf-njcAGm9cg74/102/image.jpg"
    },
    {
      "id": "custom_26f24f1b-9963-4043-b04f-1df34989ac19",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63bb-3910-743a-8b59-f72800e5fb07.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a queen-size bed, plum and grey pillows, and an owl painting above the headboard at Pierpont Apartments in Westerville, Ohio.",
        "public_id": "019d63bb-3910-743a-8b59-f72800e5fb07",
        "storage_key": "property/6767906449167362/019d63bb-3910-743a-8b59-f72800e5fb07.webp"
      },
      "title": "Apartment",
      "description": "Relax and unwind in this inviting bedroom, featuring a plush queen-size bed and tasteful decor. A striking owl painting adds a touch of personality to the space.",
      "link": "",
      "alt_text": "Cozy bedroom with a queen-size bed, plum and grey pillows, and an owl painting above the headboard at Pierpont Apartments in Westerville, Ohio.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/pET-qYXRYC8qkulwgxZdLMZqYoSGcJ9nnCuBE6noQEA/102/image.jpg"
    },
    {
      "id": "custom_11e927c0-08d4-4bce-8b08-4a42befe9495",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63bb-44a9-71fe-b0ad-a61b16675ba7.webp",
      "image_media": {
        "alt_text": "Bedroom with a white dresser, mirror, lamp, and a bed with gray and white bedding at Pierpont Apartments in Westerville, Ohio.",
        "public_id": "019d63bb-44a9-71fe-b0ad-a61b16675ba7",
        "storage_key": "property/6767906449167362/019d63bb-44a9-71fe-b0ad-a61b16675ba7.webp"
      },
      "title": "Apartment",
      "description": "A serene bedroom featuring a stylish white dresser topped with decorative items, a striking sunburst mirror, and a cozy bed dressed in elegant gray and white linens.",
      "link": "",
      "alt_text": "Bedroom with a white dresser, mirror, lamp, and a bed with gray and white bedding at Pierpont Apartments in Westerville, Ohio.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/cRMbYNMNsk6gSYn7cXj8s44c8pvLxocAR8LOgt0RblA/119/image.jpg"
    },
    {
      "id": "custom_be61b841-61f1-4143-9910-aa04af7c4d44",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63bb-3c9b-7108-9368-89c617424397.webp",
      "image_media": {
        "alt_text": "Kitchen with granite countertops, stainless steel appliances, and breakfast bar with stools at Pierpont Apartments in Westerville, Ohio.",
        "public_id": "019d63bb-3c9b-7108-9368-89c617424397",
        "storage_key": "property/6767906449167362/019d63bb-3c9b-7108-9368-89c617424397.webp"
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring granite countertops, a breakfast bar with stools, stainless steel appliances including a refrigerator, stove, and microwave, and ample cabinet space.",
      "link": "",
      "alt_text": "Kitchen with granite countertops, stainless steel appliances, and breakfast bar with stools at Pierpont Apartments in Westerville, Ohio.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/JL2GnKY8MWqfOpARcb0wbSiFA_0L-Wf7klpWze9v_Nw/119/image.jpg"
    },
    {
      "id": "custom_130081c9-8725-47c5-9240-58b5074fb537",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63bb-43f8-765d-9704-c7145ee86222.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and white cabinets at Pierpont Apartments in Westerville, Ohio.",
        "public_id": "019d63bb-43f8-765d-9704-c7145ee86222",
        "storage_key": "property/6767906449167362/019d63bb-43f8-765d-9704-c7145ee86222.webp"
      },
      "title": "Apartment",
      "description": "Stylish kitchen featuring stainless steel appliances, granite countertops, and ample cabinet space, perfect for everyday cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and white cabinets at Pierpont Apartments in Westerville, Ohio.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/I0CcUMpyPdtA9r6lwDsqs1H8F_9MrOIRB_Q6wdc8fuc/117/image.jpg"
    },
    {
      "id": "custom_56d75e7d-a56b-4ac2-ae4b-6e1bbcb35871",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63bb-4f94-775d-ad7f-85b477ece9ea.webp",
      "image_media": {
        "alt_text": "Kitchen island with granite countertops and stainless steel dishwasher, opens to living room and bathroom at Pierpont Apartments in Westerville, Ohio.",
        "public_id": "019d63bb-4f94-775d-ad7f-85b477ece9ea",
        "storage_key": "property/6767906449167362/019d63bb-4f94-775d-ad7f-85b477ece9ea.webp"
      },
      "title": "Apartment",
      "description": "Modern kitchen with granite countertops and stainless steel appliances, including a dishwasher. The space flows into a comfortable living area and a clean bathroom.",
      "link": "",
      "alt_text": "Kitchen island with granite countertops and stainless steel dishwasher, opens to living room and bathroom at Pierpont Apartments in Westerville, Ohio.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/fapJLIA2OL2Qab4fFVvMWAL2JYVXtwCK1eKt8S_GVrs/118/image.jpg"
    },
    {
      "id": "custom_b39f645a-498f-4f8b-843c-da4d6f7a7392",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63bb-5399-733b-a4b5-241f64783690.webp",
      "image_media": {
        "alt_text": "Kitchen island with granite countertop and a breakfast bar next to a dining table with chairs at Pierpont Apartments in Westerville, Ohio.",
        "public_id": "019d63bb-5399-733b-a4b5-241f64783690",
        "storage_key": "property/6767906449167362/019d63bb-5399-733b-a4b5-241f64783690.webp"
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring a granite-top island and a dining area, perfect for entertaining or casual meals.",
      "link": "",
      "alt_text": "Kitchen island with granite countertop and a breakfast bar next to a dining table with chairs at Pierpont Apartments in Westerville, Ohio.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/OhE-qFXV5Y--HOG2fvgl38JVKG-ILtky7XTWldo4HDs/104/image.jpg"
    },
    {
      "id": "custom_e05a8ce9-d1f6-41b5-b993-f69468cd605a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63bb-65f6-72e3-8995-8413c1e60cc0.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and ample cabinet space at Pierpont Apartments in Westerville, Ohio.",
        "public_id": "019d63bb-65f6-72e3-8995-8413c1e60cc0",
        "storage_key": "property/6767906449167362/019d63bb-65f6-72e3-8995-8413c1e60cc0.webp"
      },
      "title": "Apartment",
      "description": "Step into this beautifully appointed kitchen, featuring sleek stainless steel appliances, elegant granite countertops, and plenty of cabinet storage for all your culinary needs.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and ample cabinet space at Pierpont Apartments in Westerville, Ohio.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/DXyKW8BW46vFooRMcmHiddnmTXqwFjTI9JwKt3p9S2U/119/image.jpg"
    },
    {
      "id": "custom_0e87c253-1074-4895-80e5-768d143fc70d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63bb-64d4-70ce-8a87-b46784db6ce2.webp",
      "image_media": {
        "alt_text": "Kitchen with stainless steel appliances and granite countertops at Pierpont Apartments in Westerville, Ohio.",
        "public_id": "019d63bb-64d4-70ce-8a87-b46784db6ce2",
        "storage_key": "property/6767906449167362/019d63bb-64d4-70ce-8a87-b46784db6ce2.webp"
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring stainless steel appliances, granite countertops, and ample cabinet space.",
      "link": "",
      "alt_text": "Kitchen with stainless steel appliances and granite countertops at Pierpont Apartments in Westerville, Ohio.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/Bq9N1d3y4voxkytxsv6dTHDZWsIL_YvBLFXwQM0WOZo/102/image.jpg"
    },
    {
      "id": "custom_62ecc7d8-8c24-4f8a-ba1f-26dda28431f6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63bb-62b8-75c9-b000-d30064cc7cf5.webp",
      "image_media": {
        "alt_text": "Modern living room and open kitchen with breakfast bar at Pierpont Apartments in Westerville, Ohio.",
        "public_id": "019d63bb-62b8-75c9-b000-d30064cc7cf5",
        "storage_key": "property/6767906449167362/019d63bb-62b8-75c9-b000-d30064cc7cf5.webp"
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a comfortable sofa, modern entertainment center, and open-concept kitchen with a breakfast bar, perfect for entertaining.",
      "link": "",
      "alt_text": "Modern living room and open kitchen with breakfast bar at Pierpont Apartments in Westerville, Ohio.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/LG-nB9DruqYX1ubEkBB4bEbjR-QG8LkjbIV2rFiBXLU/118/image.jpg"
    },
    {
      "id": "custom_2bd6697b-6b24-4279-9e89-6e5ff0ad40bd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63bb-6900-7731-9421-ad8f39a5a888.webp",
      "image_media": {
        "alt_text": "Stylish living room and kitchen area with a gray sofa, accent chair, and breakfast bar at Pierpont Apartments in Westerville, Ohio.",
        "public_id": "019d63bb-6900-7731-9421-ad8f39a5a888",
        "storage_key": "property/6767906449167362/019d63bb-6900-7731-9421-ad8f39a5a888.webp"
      },
      "title": "Apartment",
      "description": "Experience comfortable living in this open-concept apartment, featuring a modern kitchen and a spacious living area perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Stylish living room and kitchen area with a gray sofa, accent chair, and breakfast bar at Pierpont Apartments in Westerville, Ohio.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/4sMs2CBEbM1xTtIlsxq-2_rXfrRkMhc5-v2snPcFI_k/119/image.jpg"
    },
    {
      "id": "custom_ddfab339-7710-44be-bee8-be7fc980556c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63bb-7a4d-7511-90b0-d72c51e32556.webp",
      "image_media": {
        "alt_text": "Cozy living room with gray sofa, coffee table, and green lamp at Pierpont Apartments in Westerville, Ohio.",
        "public_id": "019d63bb-7a4d-7511-90b0-d72c51e32556",
        "storage_key": "property/6767906449167362/019d63bb-7a4d-7511-90b0-d72c51e32556.webp"
      },
      "title": "Apartment",
      "description": "Relax in this inviting living room, featuring a comfortable gray sofa, a stylish coffee table, and ambient lighting.",
      "link": "",
      "alt_text": "Cozy living room with gray sofa, coffee table, and green lamp at Pierpont Apartments in Westerville, Ohio.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/8dSyMeHsa4F6lE3D_V6VaD5CdRPHGxWsPchacJdcTpg/104/image.jpg"
    },
    {
      "id": "custom_02340cf8-a24f-4cfd-a90f-b6df53793c19",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63bb-813c-7477-86f6-b453f8b9dd12.webp",
      "image_media": {
        "alt_text": "Stylish living room with a charcoal grey sofa, white and green throw pillows, and a light blue blanket draped over the armrest at Pierpont Apartments in Westerville, Ohio.",
        "public_id": "019d63bb-813c-7477-86f6-b453f8b9dd12",
        "storage_key": "property/6767906449167362/019d63bb-813c-7477-86f6-b453f8b9dd12.webp"
      },
      "title": "Apartment",
      "description": "Discover comfort and style in this inviting living room, featuring a plush sofa adorned with decorative pillows and a cozy throw blanket.",
      "link": "",
      "alt_text": "Stylish living room with a charcoal grey sofa, white and green throw pillows, and a light blue blanket draped over the armrest at Pierpont Apartments in Westerville, Ohio.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/UZlWIZLbf-MpWN8pDLps_F7rYDFK0ipsl72rzQq2gZg/119/image.jpg"
    },
    {
      "id": "custom_3de896be-02e8-40e3-befd-adb1b8bc2c51",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63bb-8787-714e-a19a-166f88b9a1bd.webp",
      "image_media": {
        "alt_text": "Stylish bedroom with a modern dresser, sunburst mirror, and a bed with grey and white linens at Pierpont Apartments in Westerville, Ohio.",
        "public_id": "019d63bb-8787-714e-a19a-166f88b9a1bd",
        "storage_key": "property/6767906449167362/019d63bb-8787-714e-a19a-166f88b9a1bd.webp"
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this beautifully appointed bedroom, featuring a sleek dresser, decorative mirror, and plush bedding.",
      "link": "",
      "alt_text": "Stylish bedroom with a modern dresser, sunburst mirror, and a bed with grey and white linens at Pierpont Apartments in Westerville, Ohio.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/KCdMuH-bH9oJ4fGc0yiozNjxm6oXD-6HMbK6B4Br1KY/119/image.jpg"
    },
    {
      "id": "custom_d9611548-6527-4e23-9ec0-d76b25d82a5b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63bb-8bba-7152-b9c3-e40d27d8fe3a.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstand, dresser, and window at Pierpont Apartments in Westerville, Ohio.",
        "public_id": "019d63bb-8bba-7152-b9c3-e40d27d8fe3a",
        "storage_key": "property/6767906449167362/019d63bb-8bba-7152-b9c3-e40d27d8fe3a.webp"
      },
      "title": "Apartment",
      "description": "A cozy bedroom featuring a queen-size bed with plush bedding, a decorative nightstand, a dresser, and a large window with gray curtains.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, nightstand, dresser, and window at Pierpont Apartments in Westerville, Ohio.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/geEROZLia6PNhy6AB98EtO1ZgQ2bolev3ea6LAm79J4/118/image.jpg"
    },
    {
      "id": "custom_143302e9-8f8b-4df0-b249-6b69827c565e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63bb-990f-7588-9f0c-6240c3e2bd45.webp",
      "image_media": {
        "alt_text": "Desk and water heater in apartment at Pierpont Apartments in Westerville, Ohio.",
        "public_id": "019d63bb-990f-7588-9f0c-6240c3e2bd45",
        "storage_key": "property/6767906449167362/019d63bb-990f-7588-9f0c-6240c3e2bd45.webp"
      },
      "title": "Apartment",
      "description": "A desk with a chair and decor is shown next to a water heater unit. This image depicts an area within an apartment unit.",
      "link": "",
      "alt_text": "Desk and water heater in apartment at Pierpont Apartments in Westerville, Ohio.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/MEG1UDzMGhi1p3SGQrdJp_lHe_04l-iZHHzmJvjmJrI/102/image.jpg"
    },
    {
      "id": "custom_b49d8f6d-9262-4789-b9bd-5407976cbb87",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63bb-2af2-720b-9ec5-de02bf70b96d.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a white vanity, chrome faucet, and decorative mirror at Pierpont Apartments in Westerville, Ohio.",
        "public_id": "019d63bb-2af2-720b-9ec5-de02bf70b96d",
        "storage_key": "property/6767906449167362/019d63bb-2af2-720b-9ec5-de02bf70b96d.webp"
      },
      "title": "Apartment",
      "description": "This bright bathroom features a clean white vanity, a spacious bathtub with a teal shower curtain, and decorative accents like a hanging plant and framed artwork.",
      "link": "",
      "alt_text": "Modern bathroom with a white vanity, chrome faucet, and decorative mirror at Pierpont Apartments in Westerville, Ohio.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/v89RPK9fTcRnSUU8zUn8VOok5wgWgJ3mjSYxRednltE/119/image.jpg"
    },
    {
      "id": "custom_274b805c-2eb0-43b3-8c36-430c1643b1f3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63bb-b5bc-72e1-abbc-37add5cf4bef.webp",
      "image_media": {
        "alt_text": "Modern bathroom with white tub, shower, toilet, and vanity with a large mirror at Pierpont Apartments in Westerville, Ohio.",
        "public_id": "019d63bb-b5bc-72e1-abbc-37add5cf4bef",
        "storage_key": "property/6767906449167362/019d63bb-b5bc-72e1-abbc-37add5cf4bef.webp"
      },
      "title": "Apartment",
      "description": "Step into a clean and updated bathroom featuring a spacious tub/shower combo, modern vanity, and a large decorative mirror. Perfect for a relaxing retreat.",
      "link": "",
      "alt_text": "Modern bathroom with white tub, shower, toilet, and vanity with a large mirror at Pierpont Apartments in Westerville, Ohio.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/qYRBq7rfmWFQOqhmy4qtBMqGSQuE9gNo1LAS_ZAT12o/119/image.jpg"
    },
    {
      "id": "custom_06a7a230-a238-4f81-807c-09cadf6b7e31",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63bb-a1b8-75ef-b575-7ad5c9c71a93.webp",
      "image_media": {
        "alt_text": "Empty closet with wire shelving and a vent at Pierpont Apartments in Westerville, Ohio.",
        "public_id": "019d63bb-a1b8-75ef-b575-7ad5c9c71a93",
        "storage_key": "property/6767906449167362/019d63bb-a1b8-75ef-b575-7ad5c9c71a93.webp"
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet with ample shelving for storage.",
      "link": "",
      "alt_text": "Empty closet with wire shelving and a vent at Pierpont Apartments in Westerville, Ohio.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/_wyRJF9xFE2568ESEu_9_JMnqtX1dRhPkCqnDC4oebI/104/image.jpg"
    },
    {
      "id": "custom_f0d9c008-9618-48ea-88e1-2da34dbe41eb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63bb-a354-75bc-a7ec-55081fa3f6bd.webp",
      "image_media": {
        "alt_text": "Walk-in closet with shelving and a water heater at Pierpont Apartments in Westerville, Ohio.",
        "public_id": "019d63bb-a354-75bc-a7ec-55081fa3f6bd",
        "storage_key": "property/6767906449167362/019d63bb-a354-75bc-a7ec-55081fa3f6bd.webp"
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet featuring ample shelving for storage and a water heater, perfect for keeping your home organized.",
      "link": "",
      "alt_text": "Walk-in closet with shelving and a water heater at Pierpont Apartments in Westerville, Ohio.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/NlUX0Gx94GKsfPvxlUvYtxAV_SA8SFVjkVAp68s7Z9w/119/image.jpg"
    },
    {
      "id": "custom_3677b471-2ff1-4c03-8a5a-416270af1e47",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63bb-afb1-719b-bcf6-e88620dbd9d4.webp",
      "image_media": {
        "alt_text": "Washer and dryer in a laundry room at Pierpont Apartments in Westerville, Ohio.",
        "public_id": "019d63bb-afb1-719b-bcf6-e88620dbd9d4",
        "storage_key": "property/6767906449167362/019d63bb-afb1-719b-bcf6-e88620dbd9d4.webp"
      },
      "title": "Apartment",
      "description": "In-unit washer and dryer for your convenience. Keep your clothes fresh without leaving your apartment.",
      "link": "",
      "alt_text": "Washer and dryer in a laundry room at Pierpont Apartments in Westerville, Ohio.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/7iFxaq_dVxfQg0pEk9j_4KOZqQkawl9x2yja1XEHZi4/118/image.jpg"
    },
    {
      "id": "custom_1555cba6-1b28-45dc-b658-97f664536018",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63bb-bca1-7118-900a-55537cc31d19.webp",
      "image_media": {
        "alt_text": "Stylish seating area with a tan leather sofa, dark gray armchairs, and a round coffee table at Pierpont Apartments in Westerville, Ohio.",
        "public_id": "019d63bb-bca1-7118-900a-55537cc31d19",
        "storage_key": "property/6767906449167362/019d63bb-bca1-7118-900a-55537cc31d19.webp"
      },
      "title": "Community",
      "description": "Relax in the beautifully appointed community lounge area, featuring comfortable seating and modern decor.",
      "link": "",
      "alt_text": "Stylish seating area with a tan leather sofa, dark gray armchairs, and a round coffee table at Pierpont Apartments in Westerville, Ohio.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/p0xE6tSIl8TbIEbBXbsOGMUktZ71vqMPePYsAg1CCjM/104/image.jpg"
    },
    {
      "id": "custom_fccaaccf-a9e1-4384-90f4-d386d3a690d2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63bb-be26-73e7-8845-7a8e0002c9a2.webp",
      "image_media": {
        "alt_text": "Living room with a brown leather sofa, dark gray armchairs, and a round coffee table at Pierpont Apartments in Westerville, Ohio.",
        "public_id": "019d63bb-be26-73e7-8845-7a8e0002c9a2",
        "storage_key": "property/6767906449167362/019d63bb-be26-73e7-8845-7a8e0002c9a2.webp"
      },
      "title": "Community",
      "description": "Spacious living room featuring a comfortable brown leather sofa, stylish armchairs, and a modern coffee table, perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Living room with a brown leather sofa, dark gray armchairs, and a round coffee table at Pierpont Apartments in Westerville, Ohio.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/5q6ZsOLTy8ovSZEI3GtCZwzyNE1FVMqfWbC7YhxuLdA/117/image.jpg"
    },
    {
      "id": "custom_2dad3dc7-c4a9-44a0-ad0c-b2de822323a1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63bb-c8b2-77cb-a8b7-7cc210bc91bd.webp",
      "image_media": {
        "alt_text": "Interior of a community lounge area with a tan leather sofa, dark gray accent chairs, and a coffee table at Pierpont Apartments in Westerville, Ohio.",
        "public_id": "019d63bb-c8b2-77cb-a8b7-7cc210bc91bd",
        "storage_key": "property/6767906449167362/019d63bb-c8b2-77cb-a8b7-7cc210bc91bd.webp"
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish community lounge, featuring comfortable seating and a modern aesthetic. Perfect for socializing or enjoying a quiet moment.",
      "link": "",
      "alt_text": "Interior of a community lounge area with a tan leather sofa, dark gray accent chairs, and a coffee table at Pierpont Apartments in Westerville, Ohio.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/UJFZxTBJdzqDYJH7UX1Kk0wz2EZYkqOqr4o-ZksJwsQ/116/image.jpg"
    },
    {
      "id": "custom_7c1c1fa6-853a-4975-a734-8a7b4e985f31",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63ba-f98b-704a-81d2-e0e57056ac1c.webp",
      "image_media": {
        "alt_text": "Clubhouse lounge area with a large orange sofa, coffee table, and seating at Pierpont Apartments in Westerville, Ohio.",
        "public_id": "019d63ba-f98b-704a-81d2-e0e57056ac1c",
        "storage_key": "property/6767906449167362/019d63ba-f98b-704a-81d2-e0e57056ac1c.webp"
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish clubhouse lounge, featuring comfortable seating and a contemporary design.",
      "link": "",
      "alt_text": "Clubhouse lounge area with a large orange sofa, coffee table, and seating at Pierpont Apartments in Westerville, Ohio.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/JA0Gtk8iAomkwjJxcgmqh4x2jPOjpM-PvXIZEDAkfuA/102/image.jpg"
    },
    {
      "id": "custom_90ee8a52-a31b-446a-8b85-4ac5c1382100",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63bb-d14d-727f-89b4-a2954d156bb5.webp",
      "image_media": {
        "alt_text": "Gym with a cable crossover machine, exercise bike, and stability balls at Pierpont Apartments in Westerville, Ohio.",
        "public_id": "019d63bb-d14d-727f-89b4-a2954d156bb5",
        "storage_key": "property/6767906449167362/019d63bb-d14d-727f-89b4-a2954d156bb5.webp"
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring a variety of cardio and strength training equipment for a complete workout.",
      "link": "",
      "alt_text": "Gym with a cable crossover machine, exercise bike, and stability balls at Pierpont Apartments in Westerville, Ohio.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/it3g1VcgQT2a4LBDHYJE7r0mVXhGecgOh8nhSv1E1d4/119/image.jpg"
    },
    {
      "id": "custom_917568bb-4f40-40ef-9a3c-f469ab593f26",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63bb-cd07-73bb-9fb6-e185576ee94a.webp",
      "image_media": {
        "alt_text": "Stationary bike and rowing machine in a well-lit gym at Pierpont Apartments in Westerville, Ohio.",
        "public_id": "019d63bb-cd07-73bb-9fb6-e185576ee94a",
        "storage_key": "property/6767906449167362/019d63bb-cd07-73bb-9fb6-e185576ee94a.webp"
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring cardio machines and free weights for your workout needs.",
      "link": "",
      "alt_text": "Stationary bike and rowing machine in a well-lit gym at Pierpont Apartments in Westerville, Ohio.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/jPFx2CIirI9DAh2steq7UsRSH2OrObpoqFdAEdy06QU/114/image.jpg"
    },
    {
      "id": "custom_e46b0ee3-4650-474c-977c-f7fb24fa6b8f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63bb-d60f-70cd-93cd-75dcb373ea79.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills and elliptical machines at Pierpont Apartments in Westerville, Ohio.",
        "public_id": "019d63bb-d60f-70cd-93cd-75dcb373ea79",
        "storage_key": "property/6767906449167362/019d63bb-d60f-70cd-93cd-75dcb373ea79.webp"
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with treadmills, ellipticals, and weight machines for a complete workout.",
      "link": "",
      "alt_text": "Fitness center with treadmills and elliptical machines at Pierpont Apartments in Westerville, Ohio.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/Qhkn5EDx_C9tmzZ4huXdeDBpP1RQ7EXDYUja7l9YiTg/119/image.jpg"
    },
    {
      "id": "custom_a5dedb2b-296c-4d67-8b99-6a22603cd490",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63bb-e78c-77c5-85ee-ba11a713fae4.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and trees in the background at Pierpont Apartments in Westerville, Ohio.",
        "public_id": "019d63bb-e78c-77c5-85ee-ba11a713fae4",
        "storage_key": "property/6767906449167362/019d63bb-e78c-77c5-85ee-ba11a713fae4.webp"
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by lush greenery and comfortable lounge chairs.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and trees in the background at Pierpont Apartments in Westerville, Ohio.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/TfnhrWvVbZUQbQPrPsZET95HF1amvV2E2N4sdjUUAC4/102/image.jpg"
    },
    {
      "id": "custom_4d5f7502-ca2c-4dba-940a-82b35efa98bf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d7918-e097-7678-8d36-510b7e1c56b1.webp",
      "image_media": {
        "alt_text": "Pierpont community club house and office exterior building with blue awning.",
        "public_id": "019d7918-e097-7678-8d36-510b7e1c56b1",
        "storage_key": "property/6767906449167362/019d7918-e097-7678-8d36-510b7e1c56b1.webp"
      },
      "title": "Community",
      "description": "Welcome to the Pierpont community club house and office. This building is the heart of our community and provides a central hub for residents.",
      "link": "",
      "alt_text": "Pierpont community club house and office exterior building with blue awning.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2fd0e861-a0ec-4950-972d-cd00adeccef6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d7918-cd26-75ac-86c5-d05a90258793.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings and parking lots.",
        "public_id": "019d7918-cd26-75ac-86c5-d05a90258793",
        "storage_key": "property/6767906449167362/019d7918-cd26-75ac-86c5-d05a90258793.webp"
      },
      "title": "Community",
      "description": "Exterior view of blue apartment buildings with balconies and surrounding parking areas. This image showcases the community's layout and amenities.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings and parking lots.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_915673af-6127-4f1a-b272-fc86d9cc5601",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d7918-cf47-7181-b112-01458f527d50.webp",
      "image_media": {
        "alt_text": "Laundry room with washer and dryer, view into bedroom",
        "public_id": "019d7918-cf47-7181-b112-01458f527d50",
        "storage_key": "property/6767906449167362/019d7918-cf47-7181-b112-01458f527d50.webp"
      },
      "title": "Apartment",
      "description": "In-unit laundry room with washer and dryer, conveniently located near the bedroom.",
      "link": "",
      "alt_text": "Laundry room with washer and dryer, view into bedroom",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4c32fdae-8617-49d8-ba43-cd611cfb9e88",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d7918-ca56-7015-b50e-54f9c4ecca5e.webp",
      "image_media": {
        "alt_text": "Stylish communal lounge with vaulted ceiling, featuring orange sofa, grey armchairs, and coffee table.",
        "public_id": "019d7918-ca56-7015-b50e-54f9c4ecca5e",
        "storage_key": "property/6767906449167362/019d7918-ca56-7015-b50e-54f9c4ecca5e.webp"
      },
      "title": "Community",
      "description": "Relax and socialize in our modern communal lounge, complete with comfortable seating and elegant decor. A perfect space for residents to gather and unwind.",
      "link": "",
      "alt_text": "Stylish communal lounge with vaulted ceiling, featuring orange sofa, grey armchairs, and coffee table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7dfe465d-ad8e-47ea-b7ed-1dadf26b81ed",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d7918-b22c-749b-aadd-94d9e345092b.webp",
      "image_media": {
        "alt_text": "Mailboxes under a covered pavilion with white fencing and landscaping.",
        "public_id": "019d7918-b22c-749b-aadd-94d9e345092b",
        "storage_key": "property/6767906449167362/019d7918-b22c-749b-aadd-94d9e345092b.webp"
      },
      "title": "Community",
      "description": "Conveniently located mailboxes housed under a charming pavilion, complete with white fencing and lush landscaping, offering a touch of aesthetic appeal to the community grounds.",
      "link": "",
      "alt_text": "Mailboxes under a covered pavilion with white fencing and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4c5ab3b3-f77d-4ee6-8edc-5b96eaeeba0a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d7918-b23b-7547-ac8d-957f530a0022.webp",
      "image_media": {
        "alt_text": "Living room with sofa, coffee table, and kitchen in the background.",
        "public_id": "019d7918-b23b-7547-ac8d-957f530a0022",
        "storage_key": "property/6767906449167362/019d7918-b23b-7547-ac8d-957f530a0022.webp"
      },
      "title": "Apartment",
      "description": "Comfortable and modern living room featuring a plush sofa, stylish coffee table, and an open-concept kitchen area, perfect for entertaining.",
      "link": "",
      "alt_text": "Living room with sofa, coffee table, and kitchen in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8466c096-412e-48cb-9b05-9b085bfb849f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d7918-b030-77e6-bf9c-9fa74ca8ddab.webp",
      "image_media": {
        "alt_text": "Bedroom with a bed, desk, and closet.",
        "public_id": "019d7918-b030-77e6-bf9c-9fa74ca8ddab",
        "storage_key": "property/6767906449167362/019d7918-b030-77e6-bf9c-9fa74ca8ddab.webp"
      },
      "title": "Apartment",
      "description": "A beautifully appointed bedroom featuring a comfortable bed, a functional desk area, and a spacious walk-in closet, perfect for modern living.",
      "link": "",
      "alt_text": "Bedroom with a bed, desk, and closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_008afdad-66d3-429f-946a-1737a1312ecb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d7918-aed7-724f-83d8-b601fee7ffe0.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and a dining area.",
        "public_id": "019d7918-aed7-724f-83d8-b601fee7ffe0",
        "storage_key": "property/6767906449167362/019d7918-aed7-724f-83d8-b601fee7ffe0.webp"
      },
      "title": "Apartment",
      "description": "Bright and airy apartment kitchen featuring granite countertops, a stainless steel dishwasher, and a dining area with two chairs and a small table.",
      "link": "",
      "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and a dining area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_425cbcc8-687d-4e0b-a437-a280e8daac46",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63ba-208b-74ad-884a-68f9b4d96b25.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a white vanity, sink, mirror, and toilet with a blue shower curtain.",
        "public_id": "019d63ba-208b-74ad-884a-68f9b4d96b25",
        "storage_key": "property/6767906449167362/019d63ba-208b-74ad-884a-68f9b4d96b25.webp"
      },
      "title": "Apartment",
      "description": "Enjoy the convenience and style of this modern bathroom, featuring a clean white vanity, a spacious sink, and elegant fixtures.",
      "link": "",
      "alt_text": "Modern bathroom with a white vanity, sink, mirror, and toilet with a blue shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_98e15591-098a-4079-a2af-4cf091205cbe",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63ba-1212-7481-a25b-47a58d130efd.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and trees in the background.",
        "public_id": "019d63ba-1212-7481-a25b-47a58d130efd",
        "storage_key": "property/6767906449167362/019d63ba-1212-7481-a25b-47a58d130efd.webp"
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by lush greenery and comfortable lounge chairs.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and trees in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_3aa4c18f-c84a-4d98-9d8d-ccd586810bee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "poi_name": "Topgolf Columbus",
      "poi_type": "Restaurants",
      "poi_address": "2000 Ikea Wy, Columbus, OH 43240, USA",
      "poi_short_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_long_description": "People say this restaurant offers a fun atmosphere with games and a bar. They also highlight the friendly and attentive staff, and the fast service.\n\nSome reviews mention the food can be pricey.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63b8-83a3-728c-8e23-906931c2f23c.webp",
      "poi_featured_image_media": {
        "alt_text": "Outdoor patio seating with umbrellas and tables at dusk.",
        "public_id": "019d63b8-83a3-728c-8e23-906931c2f23c",
        "storage_key": "property/6767906449167362/019d63b8-83a3-728c-8e23-906931c2f23c.webp"
      },
      "poi_business_url": "https://topgolf.com/us/columbus/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12607087257987140669&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "topgolf-columbus",
      "poi_latitude": "40.1500953",
      "poi_longitude": "-82.9639854",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 614-317-1003",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019dbbbb-615f-7798-8da3-ec0fb37759ad.webp",
      "poi_map_icon_media": {
        "alt_text": "Cutlery icon",
        "public_id": "019dbbbb-615f-7798-8da3-ec0fb37759ad",
        "storage_key": "property/6767906449167362/019dbbbb-615f-7798-8da3-ec0fb37759ad.webp"
      },
      "poi_google_place_id": "ChIJ89GzoEX0OIgRPUyt4BBf9a4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_ca6f67a3-0e2e-4958-a043-ffbc8c84897d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "poi_name": "The Cheesecake Factory",
      "poi_type": "Restaurants",
      "poi_address": "1566 Polaris Pkwy #124, Columbus, OH 43240, USA",
      "poi_short_description": "American chain restaurant offering sizable portions from a vast menu including signature cheesecake",
      "poi_long_description": "Diners say this restaurant serves delicious cheesecake, orange chicken, and a variety of other dishes. They also highlight the friendly and attentive service, and the spacious patio seating.\n\nSome reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019dbbba-c598-74e2-a120-0c8781a77978.webp",
      "poi_featured_image_media": {
        "alt_text": "The Cheesecake Factory restaurant, bakery, and bar exterior with illuminated signage at dusk.",
        "public_id": "019dbbba-c598-74e2-a120-0c8781a77978",
        "storage_key": "property/6767906449167362/019dbbba-c598-74e2-a120-0c8781a77978.webp"
      },
      "poi_business_url": "https://locations.thecheesecakefactory.com/oh/columbus-144.html?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=15407766099093437679&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-cheesecake-factory",
      "poi_latitude": "40.1453589",
      "poi_longitude": "-82.9779861",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 614-848-6700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019dbbbb-615f-7798-8da3-ec0fb37759ad.webp",
      "poi_map_icon_media": {
        "alt_text": "Cutlery icon",
        "public_id": "019dbbbb-615f-7798-8da3-ec0fb37759ad",
        "storage_key": "property/6767906449167362/019dbbbb-615f-7798-8da3-ec0fb37759ad.webp"
      },
      "poi_google_place_id": "ChIJdSXy_WP0OIgR7zzFHqJh09U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_d25067c1-b1f9-4e0f-9d20-76eb3a79b0af",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "poi_name": "Roosters",
      "poi_type": "Restaurants",
      "poi_address": "1041 Gemini Pl, Columbus, OH 43240, USA",
      "poi_short_description": "Outpost of a casual chain serving American comfort food & specializing in chicken wings.",
      "poi_long_description": "People say this chicken wings restaurant serves delicious wings, chicken sandwiches, and salads. They also highlight the family-friendly atmosphere and the attentive service.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63b9-c05b-762b-90f8-6bdf54377bd8.webp",
      "poi_featured_image_media": {
        "alt_text": "Roosters restaurant exterior with a handicap parking spot in the foreground.",
        "public_id": "019d63b9-c05b-762b-90f8-6bdf54377bd8",
        "storage_key": "property/6767906449167362/019d63b9-c05b-762b-90f8-6bdf54377bd8.webp"
      },
      "poi_business_url": "http://www.roosterswings.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6955991025052788866&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "roosters",
      "poi_latitude": "40.1470431",
      "poi_longitude": "-82.9885181",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 614-896-6460",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019dbbbb-615f-7798-8da3-ec0fb37759ad.webp",
      "poi_map_icon_media": {
        "alt_text": "Cutlery icon",
        "public_id": "019dbbbb-615f-7798-8da3-ec0fb37759ad",
        "storage_key": "property/6767906449167362/019dbbbb-615f-7798-8da3-ec0fb37759ad.webp"
      },
      "poi_google_place_id": "ChIJGV_973n0OIgRgqgTnfukiGA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chicken_wings_restaurant"
    },
    {
      "id": "custom_87275a1f-dbe4-42f7-9216-cfd69184ad02",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "8440 Lyra Dr, Columbus, OH 43240, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "People say this steakhouse serves delicious steaks and rolls. They also highlight the quick service, friendly staff, and reasonable prices.\n\nOther reviews mention the music can be loud.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019dbbba-e672-76fb-b3c5-67751c9771ec.webp",
      "poi_featured_image_media": {
        "alt_text": "Restaurant hours sign with Texas Roadhouse logo",
        "public_id": "019dbbba-e672-76fb-b3c5-67751c9771ec",
        "storage_key": "property/6767906449167362/019dbbba-e672-76fb-b3c5-67751c9771ec.webp"
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/ohio/columbus-polaris?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=5903884198006324691&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "40.140267",
      "poi_longitude": "-82.9729381",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 614-436-8300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019dbbbb-615f-7798-8da3-ec0fb37759ad.webp",
      "poi_map_icon_media": {
        "alt_text": "Cutlery icon",
        "public_id": "019dbbbb-615f-7798-8da3-ec0fb37759ad",
        "storage_key": "property/6767906449167362/019dbbbb-615f-7798-8da3-ec0fb37759ad.webp"
      },
      "poi_google_place_id": "ChIJlX7s62D0OIgR03014WXP7lE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_e862ab2c-3972-45aa-aa47-41d14bed92f9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "poi_name": "Kitchen Social",
      "poi_type": "Restaurants",
      "poi_address": "8954 Lyra Dr, Columbus, OH 43240, USA",
      "poi_short_description": "Busy venue serving global bites including pizza, tacos, seafood & sandwiches, plus cocktails & wine.",
      "poi_long_description": "People say this restaurant serves delicious and creative comfort food, including the popular cheddar scallion biscuits. They highlight the reasonable prices and lively, trendy atmosphere. They also like the friendly and attentive service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63b8-b467-71ef-9e81-9ab0d65098d8.webp",
      "poi_featured_image_media": {
        "alt_text": "A chef smiles behind a table of to-go bags, with people in the background.",
        "public_id": "019d63b8-b467-71ef-9e81-9ab0d65098d8",
        "storage_key": "property/6767906449167362/019d63b8-b467-71ef-9e81-9ab0d65098d8.webp"
      },
      "poi_business_url": "http://ourkitchensocial.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5207321762219822896&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kitchen-social",
      "poi_latitude": "40.1477388",
      "poi_longitude": "-82.9744894",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 614-505-8492",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019dbbbb-615f-7798-8da3-ec0fb37759ad.webp",
      "poi_map_icon_media": {
        "alt_text": "Cutlery icon",
        "public_id": "019dbbbb-615f-7798-8da3-ec0fb37759ad",
        "storage_key": "property/6767906449167362/019dbbbb-615f-7798-8da3-ec0fb37759ad.webp"
      },
      "poi_google_place_id": "ChIJ5cj1WOb1OIgRMA9GnI0fREg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_ac203bda-01f5-4c5e-9110-0bd5af576358",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "poi_name": "Polaris Fashion Place",
      "poi_type": "Shopping & Retail",
      "poi_address": "1500 Polaris Pkwy, Columbus, OH 43240, USA",
      "poi_short_description": "Chain retailers & specialty shops in a modern mall with kiddie events, play areas & a food court.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores, including major brands and diverse options, and a large food court with plenty of choices. They highlight the clean and bright atmosphere, and the easy access and convenient parking. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019dbbba-c671-72be-93d3-25f7ac9624d2.webp",
      "poi_featured_image_media": {
        "alt_text": "Von Maur department store interior with jewelry displays and clothing racks.",
        "public_id": "019dbbba-c671-72be-93d3-25f7ac9624d2",
        "storage_key": "property/6767906449167362/019dbbba-c671-72be-93d3-25f7ac9624d2.webp"
      },
      "poi_business_url": "https://polarisfashionplace.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12245776793403126775&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "polaris-fashion-place",
      "poi_latitude": "40.14562420000001",
      "poi_longitude": "-82.98205759999999",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 614-846-1500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019dbbbb-615e-758d-b3de-95a781a2b69e.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping bag icon",
        "public_id": "019dbbbb-615e-758d-b3de-95a781a2b69e",
        "storage_key": "property/6767906449167362/019dbbbb-615e-758d-b3de-95a781a2b69e.webp"
      },
      "poi_google_place_id": "ChIJKQyAkEH1OIgR9_OD2Ry98ak",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_a9609fac-872f-4b41-9a53-f287ed04745a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "poi_name": "IKEA",
      "poi_type": "Shopping & Retail",
      "poi_address": "1900 Ikea Wy, Columbus, OH 43240, USA",
      "poi_short_description": "Scandinavian chain selling ready-to-assemble furniture, plus textiles, lighting & home decor.",
      "poi_long_description": "People say this furniture store offers a wide selection of home furnishings, decor, and household items, with many options to suit different styles and budgets. They also highlight the good value, fun and interesting vibe, and helpful staff.\n\nSome reviews mention the layout can be confusing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63b8-98fb-7481-a8c1-3321b58fc4aa.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of a large IKEA store with yellow and blue facade, entrance doors, and a parking lot filled with cars.",
        "public_id": "019d63b8-98fb-7481-a8c1-3321b58fc4aa",
        "storage_key": "property/6767906449167362/019d63b8-98fb-7481-a8c1-3321b58fc4aa.webp"
      },
      "poi_business_url": "https://www.ikea.com/us/en/stores/columbus/?utm_source=google&utm_medium=organic&utm_campaign=map&utm_content=columbus",
      "poi_directions_map_url": "https://maps.google.com/?cid=6088231482907053057&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ikea",
      "poi_latitude": "40.150436",
      "poi_longitude": "-82.96705810000002",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 888-888-4532",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019dbbbb-615e-758d-b3de-95a781a2b69e.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping bag icon",
        "public_id": "019dbbbb-615e-758d-b3de-95a781a2b69e",
        "storage_key": "property/6767906449167362/019dbbbb-615e-758d-b3de-95a781a2b69e.webp"
      },
      "poi_google_place_id": "ChIJqbJk80P0OIgRAUwG4Ua-fVQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "furniture_store"
    },
    {
      "id": "custom_991457e0-e02d-4914-8b9d-f60a449e4fb9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "poi_name": "Saraga International Grocery",
      "poi_type": "Shopping & Retail",
      "poi_address": "1265 Morse Rd, Columbus, OH 43229, USA",
      "poi_short_description": "Grocery store selling fresh produce and meats, along with prepared foods and baked goods.",
      "poi_long_description": "People say this grocery store offers a wide variety of international foods, including Asian snacks and beverages, fresh produce, seafood, and meat. They also highlight the reasonable prices and the presence of a bakery, restaurants, and a phone store within the plaza.\n\nSome reviews mention the store can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63b8-7c1a-736f-b09c-4e7635f0ea8e.webp",
      "poi_featured_image_media": {
        "alt_text": "Saraga International Grocery store exterior with signage",
        "public_id": "019d63b8-7c1a-736f-b09c-4e7635f0ea8e",
        "storage_key": "property/6767906449167362/019d63b8-7c1a-736f-b09c-4e7635f0ea8e.webp"
      },
      "poi_business_url": "http://saragaohio.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15469160277800290888&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "saraga-international-grocery",
      "poi_latitude": "40.0599556",
      "poi_longitude": "-82.98528329999999",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 614-447-8588",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019dbbbb-61c0-7798-a10b-86b25e39a930.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping cart icon",
        "public_id": "019dbbbb-61c0-7798-a10b-86b25e39a930",
        "storage_key": "property/6767906449167362/019dbbbb-61c0-7798-a10b-86b25e39a930.webp"
      },
      "poi_google_place_id": "ChIJccf2c3mLOIgRSIreQ1B_rdY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_4c8f6e32-4d96-4f13-bce1-54a2d90a6dff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "4100 Easton Gateway Dr, Columbus, OH 43219, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "People say this grocery store offers a wide variety of organic and vegan options, as well as a hot bar, salad bar, and pizza. They also highlight the quick checkout, helpful staff, and clean, organized atmosphere.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63b9-c0cc-715b-b00b-5075236afdca.webp",
      "poi_featured_image_media": {
        "alt_text": "Whole Foods Market storefront at night with illuminated sign and entrance.",
        "public_id": "019d63b9-c0cc-715b-b00b-5075236afdca",
        "storage_key": "property/6767906449167362/019d63b9-c0cc-715b-b00b-5075236afdca.webp"
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/easton?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=18386441578182638374&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "40.0570337",
      "poi_longitude": "-82.90956109999999",
      "poi_miles_from_property": "8.7",
      "poi_walking_minutes": "3 hours 11 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 614-536-0570",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019dbbbb-61c0-7798-a10b-86b25e39a930.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping cart icon",
        "public_id": "019dbbbb-61c0-7798-a10b-86b25e39a930",
        "storage_key": "property/6767906449167362/019dbbbb-61c0-7798-a10b-86b25e39a930.webp"
      },
      "poi_google_place_id": "ChIJLWgiIipgOIgRJnsMJzPDKf8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_05749f8b-25ac-4ad2-82b6-3978c45ee3aa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "poi_name": "Menards",
      "poi_type": "Shopping & Retail",
      "poi_address": "7241 Graphics Wy., Lewis Center, OH 43035, USA",
      "poi_short_description": "Home improvement chain with assorted building materials, tools, gardening supplies & appliances.",
      "poi_long_description": "People say this home improvement store offers a great selection of products, including lighting and shower wall panels, at decent prices. They also highlight the clean and comfortable atmosphere, and helpful staff.\n\nSome reviews mention the customer service can be disappointing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019dbbba-c7da-732b-91c3-93535c151224.webp",
      "poi_featured_image_media": {
        "alt_text": "Menards store entrance with signage.",
        "public_id": "019dbbba-c7da-732b-91c3-93535c151224",
        "storage_key": "property/6767906449167362/019dbbba-c7da-732b-91c3-93535c151224.webp"
      },
      "poi_business_url": "https://www.menards.com/store-details/store.html?store=3312&utm_source=localcard&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=9234373100519815653&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "menards",
      "poi_latitude": "40.1869444",
      "poi_longitude": "-83.02",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 740-548-6735",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019dbbbb-615e-758d-b3de-95a781a2b69e.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping bag icon",
        "public_id": "019dbbbb-615e-758d-b3de-95a781a2b69e",
        "storage_key": "property/6767906449167362/019dbbbb-615e-758d-b3de-95a781a2b69e.webp"
      },
      "poi_google_place_id": "ChIJAWvAUN_zOIgR5fnnu2gVJ4A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_8bf527fc-b397-4aaf-97cb-ade056bb2076",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "poi_name": "Otterbein University",
      "poi_type": "Education",
      "poi_address": "1 S Grove St, Westerville, OH 43081, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63b9-f3e3-721d-93c6-0818c6884a28.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of historic Otterbein University building with red brick and towers.",
        "public_id": "019d63b9-f3e3-721d-93c6-0818c6884a28",
        "storage_key": "property/6767906449167362/019d63b9-f3e3-721d-93c6-0818c6884a28.webp"
      },
      "poi_business_url": "https://www.otterbein.edu/?utm_source=GMBlisting&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=12768663309059927298&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "otterbein-university",
      "poi_latitude": "40.1268746",
      "poi_longitude": "-82.9371852",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 614-890-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019dbbbb-6189-7015-bfab-dc5b67a0bd0a.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019dbbbb-6189-7015-bfab-dc5b67a0bd0a",
        "storage_key": "property/6767906449167362/019dbbbb-6189-7015-bfab-dc5b67a0bd0a.webp"
      },
      "poi_google_place_id": "ChIJMVjn7Q_1OIgRAq0U2aBnM7E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_5dc774a5-e4ad-4bef-8677-5e142c3cb3db",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "poi_name": "Westerville Public Library",
      "poi_type": "Education",
      "poi_address": "126 S State St, Westerville, OH 43081, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this public library offers a wide variety of resources, including books, DVDs, audiobooks, periodicals, and online language learning, as well as access to a Cricut machine, 3D printing services, and a museum. They highlight the library's spacious layout, numerous activities for children and adults, and the used book sales. They also like the helpful and kind staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63b9-0a4a-7128-9ba5-d57b6c621c19.webp",
      "poi_featured_image_media": {
        "alt_text": "Boy building with colorful blocks",
        "public_id": "019d63b9-0a4a-7128-9ba5-d57b6c621c19",
        "storage_key": "property/6767906449167362/019d63b9-0a4a-7128-9ba5-d57b6c621c19.webp"
      },
      "poi_business_url": "https://www.westervillelibrary.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7529948867192542482&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "westerville-public-library",
      "poi_latitude": "40.1230063",
      "poi_longitude": "-82.9300492",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 614-882-7277",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019dbbbb-6189-7015-bfab-dc5b67a0bd0a.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019dbbbb-6189-7015-bfab-dc5b67a0bd0a",
        "storage_key": "property/6767906449167362/019dbbbb-6189-7015-bfab-dc5b67a0bd0a.webp"
      },
      "poi_google_place_id": "ChIJt9VlvhL1OIgREtXdbZnAf2g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_74b040c5-e769-4bcb-96fd-5e718b86024b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "poi_name": "Slick City Action Park",
      "poi_type": "Entertainment",
      "poi_address": "1170 Polaris Pkwy, Columbus, OH 43240, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this amusement park offers a variety of fun and exciting slides, as well as basketball courts and a play area for younger children. They highlight the clean and well-maintained facilities, and the fast-moving lines for the slides. They also like the friendly and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019dbbba-c591-775e-85a6-8b360e4b4bdb.webp",
      "poi_featured_image_media": {
        "alt_text": "Boy on a zipline ride in an indoor playground.",
        "public_id": "019dbbba-c591-775e-85a6-8b360e4b4bdb",
        "storage_key": "property/6767906449167362/019dbbba-c591-775e-85a6-8b360e4b4bdb.webp"
      },
      "poi_business_url": "https://slickcity.com/oh-northcolumbus",
      "poi_directions_map_url": "https://maps.google.com/?cid=6850122020556422697&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "slick-city-action-park",
      "poi_latitude": "40.1459242",
      "poi_longitude": "-82.9878706",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 614-665-1746",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019dbbbb-6172-75ca-97cf-6b43a0514b8f.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic",
        "public_id": "019dbbbb-6172-75ca-97cf-6b43a0514b8f",
        "storage_key": "property/6767906449167362/019dbbbb-6172-75ca-97cf-6b43a0514b8f.webp"
      },
      "poi_google_place_id": "ChIJ5ebHvXb1OIgRKb5YJ6-FEF8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_59d5396c-bfe5-42fe-b9c4-6277be8a3405",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "poi_name": "Memorial Stadium",
      "poi_type": "Entertainment",
      "poi_address": "135 Center St, Westerville, OH 43081, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019dbbba-c919-76b3-9288-833e74d6cdb8.webp",
      "poi_featured_image_media": {
        "alt_text": "View of a football field and stadium seats with a bright blue sky and white clouds.",
        "public_id": "019dbbba-c919-76b3-9288-833e74d6cdb8",
        "storage_key": "property/6767906449167362/019dbbba-c919-76b3-9288-833e74d6cdb8.webp"
      },
      "poi_business_url": "http://www.otterbeincardinals.com/sports/2011/2/23/FB_0223112028.aspx?tab=memorialstadium",
      "poi_directions_map_url": "https://maps.google.com/?cid=9224578962214339203&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "memorial-stadium",
      "poi_latitude": "40.1288396",
      "poi_longitude": "-82.93715689999999",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019dbbbb-6160-74e3-ad40-056bb737fcb5.webp",
      "poi_map_icon_media": {
        "alt_text": "Two people sitting at a table, black and white icon.",
        "public_id": "019dbbbb-6160-74e3-ad40-056bb737fcb5",
        "storage_key": "property/6767906449167362/019dbbbb-6160-74e3-ad40-056bb737fcb5.webp"
      },
      "poi_google_place_id": "ChIJjWwgOA_1OIgRg8JTNbFJBIA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_62847e85-5b92-4e4d-b223-8e5a5463b12f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "poi_name": "The Ohio Railway Museum",
      "poi_type": "Entertainment",
      "poi_address": "990 Proprietors Rd, Worthington, OH 43085, USA",
      "poi_short_description": "This long-running museum dedicated to railroad history offers streetcar & passenger car rides.",
      "poi_long_description": "People say this rail museum offers a fun ghost trolley ride with spooky effects and a variety of train cars to explore. They highlight the low cost, family-friendly atmosphere, and the knowledgeable, friendly staff. They also like the opportunity to ride the trolley at night and the unique experience of seeing the historic buildings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63b9-4b82-758e-a567-bfca2c83a4b8.webp",
      "poi_featured_image_media": {
        "alt_text": "Historic trolley car #64 on tracks with a driver visible.",
        "public_id": "019d63b9-4b82-758e-a567-bfca2c83a4b8",
        "storage_key": "property/6767906449167362/019d63b9-4b82-758e-a567-bfca2c83a4b8.webp"
      },
      "poi_business_url": "http://www.ohiorailwaymuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9472735204933527306&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-ohio-railway-museum",
      "poi_latitude": "40.0931672",
      "poi_longitude": "-83.0033828",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 614-885-7345",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019dbbbb-61cc-750d-abff-efd51d63307f.webp",
      "poi_map_icon_media": {
        "alt_text": "Logo with a house shape and the letter M",
        "public_id": "019dbbbb-61cc-750d-abff-efd51d63307f",
        "storage_key": "property/6767906449167362/019dbbbb-61cc-750d-abff-efd51d63307f.webp"
      },
      "poi_google_place_id": "ChIJEaqs-62MOIgRCmdm7XrqdYM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_10c55ae3-059d-46f8-8717-f03241d76f40",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "poi_name": "FUNBOX",
      "poi_type": "Entertainment",
      "poi_address": "1500 Polaris Pkwy, Columbus, OH 43240, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this amusement park offers a variety of fun bounce houses and obstacle courses. They also highlight the organized layout, the friendly and helpful staff, and the safe and enjoyable experience for kids.\n\nOther reviews mention the weather can be hot.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019dbbba-d65f-778b-a688-c1b1a0fa5a9b.webp",
      "poi_featured_image_media": {
        "alt_text": "Inflatable obstacle course with slides and tunnels on a sunny day.",
        "public_id": "019dbbba-d65f-778b-a688-c1b1a0fa5a9b",
        "storage_key": "property/6767906449167362/019dbbba-d65f-778b-a688-c1b1a0fa5a9b.webp"
      },
      "poi_business_url": "https://funbox.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11335957722575198290&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "funbox",
      "poi_latitude": "40.1430736",
      "poi_longitude": "-82.98079159999999",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 614-300-5860",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019dbbbb-6172-75ca-97cf-6b43a0514b8f.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic",
        "public_id": "019dbbbb-6172-75ca-97cf-6b43a0514b8f",
        "storage_key": "property/6767906449167362/019dbbbb-6172-75ca-97cf-6b43a0514b8f.webp"
      },
      "poi_google_place_id": "ChIJZ66tgC_1OIgRUtjw-nxpUZ0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_7eae1bc1-d320-41c6-ba1b-4783ac47805d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "poi_name": "Thomas Worthington Stadium",
      "poi_type": "Entertainment",
      "poi_address": "Worthington, OH 43085, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019dbbba-e667-729d-a738-3635dd0a6bad.webp",
      "poi_featured_image_media": {
        "alt_text": "Marching band on a football field at sunset, holding flags.",
        "public_id": "019dbbba-e667-729d-a738-3635dd0a6bad",
        "storage_key": "property/6767906449167362/019dbbba-e667-729d-a738-3635dd0a6bad.webp"
      },
      "poi_business_url": "http://ohiostadiums.com/stadium.php?id=2063",
      "poi_directions_map_url": "https://maps.google.com/?cid=7863766174427225839&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "thomas-worthington-stadium",
      "poi_latitude": "40.0907957",
      "poi_longitude": "-83.02971989999999",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019dbbbb-6160-74e3-ad40-056bb737fcb5.webp",
      "poi_map_icon_media": {
        "alt_text": "Two people sitting at a table, black and white icon.",
        "public_id": "019dbbbb-6160-74e3-ad40-056bb737fcb5",
        "storage_key": "property/6767906449167362/019dbbbb-6160-74e3-ad40-056bb737fcb5.webp"
      },
      "poi_google_place_id": "ChIJObF4wYWNOIgR755376u1IW0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_19566493-67ef-407c-8c06-fc4becf02426",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "poi_name": "MedVet Columbus",
      "poi_type": "Health and Wellness",
      "poi_address": "300 E Wilson Bridge Rd, Worthington, OH 43085, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63ba-18ae-7682-965e-08aa55650ee0.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of Dr. William D. Dehoff Surgery Center with a main entrance overhang and landscaping.",
        "public_id": "019d63ba-18ae-7682-965e-08aa55650ee0",
        "storage_key": "property/6767906449167362/019d63ba-18ae-7682-965e-08aa55650ee0.webp"
      },
      "poi_business_url": "https://www.medvet.com/location/columbus/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4479702789086504102&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "medvet-columbus",
      "poi_latitude": "40.10990570000001",
      "poi_longitude": "-83.0063904",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 614-846-5800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019dbbbb-6172-75ca-97cf-6b43a0514b8f.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic",
        "public_id": "019dbbbb-6172-75ca-97cf-6b43a0514b8f",
        "storage_key": "property/6767906449167362/019dbbbb-6172-75ca-97cf-6b43a0514b8f.webp"
      },
      "poi_google_place_id": "ChIJnfAaBEXzOIgRpuTTwvMZKz4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_a5448362-266a-44a1-b326-04e5572012d1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "865 Polaris Pkwy, Westerville, OH 43082, USA",
      "poi_short_description": "Clean chain known for an array of equipment and friendly staff.",
      "poi_long_description": "People say this gym offers a wide variety of cardio machines and a massage option. They also highlight the clean and hygienic environment, and the friendly and helpful staff.\n\nSome reviews mention the gym can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63ba-1ce4-744c-b6a0-15ca5a49f68e.webp",
      "poi_featured_image_media": {
        "alt_text": "Full gym with multiple weight machines and people exercising.",
        "public_id": "019d63ba-1ce4-744c-b6a0-15ca5a49f68e",
        "storage_key": "property/6767906449167362/019d63ba-1ce4-744c-b6a0-15ca5a49f68e.webp"
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/westerville-westar-center-polaris-parkway-oh?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=5267590333509561042&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "40.1441375",
      "poi_longitude": "-82.95944879999999",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 614-423-6199",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019dbbbb-6172-75ca-97cf-6b43a0514b8f.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic",
        "public_id": "019dbbbb-6172-75ca-97cf-6b43a0514b8f",
        "storage_key": "property/6767906449167362/019dbbbb-6172-75ca-97cf-6b43a0514b8f.webp"
      },
      "poi_google_place_id": "ChIJn7fa-LDzOIgR0moe2389Gkk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_b48c7968-9cb4-496d-ab44-c30e2b6decc4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "poi_name": "North YMCA - YMCA of Central Ohio",
      "poi_type": "Health and Wellness",
      "poi_address": "1640 Sandalwood Pl, Columbus, OH 43229, USA",
      "poi_short_description": "Community-focused nonprofit established in 1844 with recreational programs & services for all ages.",
      "poi_long_description": "People say this gym offers a variety of workout equipment, fitness classes, and amenities such as an indoor basketball court and pool. They also highlight the friendly and helpful staff, and the great sense of community.\n\nSome reviews mention the facilities can be run-down.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019dbbba-ef68-76a1-9f5c-72fb2ca4d26a.webp",
      "poi_featured_image_media": {
        "alt_text": "The YMCA building exterior with a large sign and an American flag.",
        "public_id": "019dbbba-ef68-76a1-9f5c-72fb2ca4d26a",
        "storage_key": "property/6767906449167362/019dbbba-ef68-76a1-9f5c-72fb2ca4d26a.webp"
      },
      "poi_business_url": "https://ymcacolumbus.org/locations/north?utm_source=google_business_profile&utm_medium=Organic&utm_campaign=gbp_north",
      "poi_directions_map_url": "https://maps.google.com/?cid=15118320695958196620&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "north-ymca---ymca-of-central-ohio",
      "poi_latitude": "40.0775233",
      "poi_longitude": "-82.9735905",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 614-389-4707",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019dbbbb-6172-75ca-97cf-6b43a0514b8f.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic",
        "public_id": "019dbbbb-6172-75ca-97cf-6b43a0514b8f",
        "storage_key": "property/6767906449167362/019dbbbb-6172-75ca-97cf-6b43a0514b8f.webp"
      },
      "poi_google_place_id": "ChIJyxY9V0CLOIgRjFEGm5IQz9E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_e92a39d9-d674-40df-a74b-082607a655ca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "poi_name": "Anytime Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "8601 Columbus Pike, Lewis Center, OH 43035, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a wide selection of well-maintained equipment and a clean, organized space. They highlight the convenient 24/7 access, the friendly and welcoming atmosphere, and the respectful members. They also like the helpful and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019dbbba-efb0-740b-9215-504115ff105d.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of an Anytime Fitness gym with cardio equipment visible through the windows.",
        "public_id": "019dbbba-efb0-740b-9215-504115ff105d",
        "storage_key": "property/6767906449167362/019dbbba-efb0-740b-9215-504115ff105d.webp"
      },
      "poi_business_url": "https://www.anytimefitness.com/locations/lewis-center-ohio-5291/?utm_source=google&utm_medium=organic-businesslisting&utm_campaign=gbp-listing&utm_content=5291",
      "poi_directions_map_url": "https://maps.google.com/?cid=4483186820016059718&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "anytime-fitness",
      "poi_latitude": "40.1661513",
      "poi_longitude": "-83.0189754",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 740-201-1055",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019dbbbb-6172-75ca-97cf-6b43a0514b8f.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic",
        "public_id": "019dbbbb-6172-75ca-97cf-6b43a0514b8f",
        "storage_key": "property/6767906449167362/019dbbbb-6172-75ca-97cf-6b43a0514b8f.webp"
      },
      "poi_google_place_id": "ChIJE7m2D4LzOIgRRjXF7Kh6Nz4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_66373f60-8bd0-4dba-a56d-bd316ad34e2f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "260 Graceland Blvd, Columbus, OH 43214, USA",
      "poi_short_description": "Workout facility featuring a pool, a sauna and a running track.",
      "poi_long_description": "Some gym goers say this gym has a great selection of cardio machines, a sauna, a pool, and a dark theater cardio room.\n\nOther reviews mention the equipment can be poorly maintained and many treadmills can be out of order.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019dbbba-fcb7-77f4-a10a-babd8fd87b7b.webp",
      "poi_featured_image_media": {
        "alt_text": "LA Fitness building exterior with large glass windows and brick accents.",
        "public_id": "019dbbba-fcb7-77f4-a10a-babd8fd87b7b",
        "storage_key": "property/6767906449167362/019dbbba-fcb7-77f4-a10a-babd8fd87b7b.webp"
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=1000&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=14263790676409297986&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "40.0661766",
      "poi_longitude": "-83.02724230000001",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 614-310-0770",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019dbbbb-6172-75ca-97cf-6b43a0514b8f.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic",
        "public_id": "019dbbbb-6172-75ca-97cf-6b43a0514b8f",
        "storage_key": "property/6767906449167362/019dbbbb-6172-75ca-97cf-6b43a0514b8f.webp"
      },
      "poi_google_place_id": "ChIJk2rA9PqMOIgRQqznIQwq88U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_be1a3d93-827b-4bc7-a501-19f5dd7bf3c8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "poi_name": "The Animal Health Organization - TAHO",
      "poi_type": "Health and Wellness",
      "poi_address": "7206 Gooding Blvd, Delaware, OH 43015, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63ba-7d0d-75b3-b48c-c70b1f0ac2bb.webp",
      "poi_featured_image_media": {
        "alt_text": "A friendly brown dog is lying down on a light-colored floor.",
        "public_id": "019d63ba-7d0d-75b3-b48c-c70b1f0ac2bb",
        "storage_key": "property/6767906449167362/019d63ba-7d0d-75b3-b48c-c70b1f0ac2bb.webp"
      },
      "poi_business_url": "http://www.animalhealth.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8125957423988917571&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-animal-health-organization---taho",
      "poi_latitude": "40.1893904",
      "poi_longitude": "-83.02873749999999",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 740-549-1950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019dbbbb-6172-75ca-97cf-6b43a0514b8f.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic",
        "public_id": "019dbbbb-6172-75ca-97cf-6b43a0514b8f",
        "storage_key": "property/6767906449167362/019dbbbb-6172-75ca-97cf-6b43a0514b8f.webp"
      },
      "poi_google_place_id": "ChIJIej5RHrxOIgRQ8XOVDkzxXA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_7ca9a858-e184-488d-9776-483bfa0a7b5a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "poi_name": "Mount Carmel Fitness Center",
      "poi_type": "Health and Wellness",
      "poi_address": "7100 Graphics Wy., Lewis Center, OH 43035, USA",
      "poi_short_description": "Gym featuring weight equipment, swimming pool, and a variety of classes, plus free Wi-Fi.",
      "poi_long_description": "People say this gym has a spacious area with a variety of equipment, as well as great amenities including a hot tub, steam room, and a pool. They also highlight the friendly and helpful staff, and the wide array of fitness classes.\n\nSome reviews mention the gym can be busy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63ba-9a5d-769e-8fe8-159a6d281d1c.webp",
      "poi_featured_image_media": {
        "alt_text": "Fitness Center exterior",
        "public_id": "019d63ba-9a5d-769e-8fe8-159a6d281d1c",
        "storage_key": "property/6767906449167362/019d63ba-9a5d-769e-8fe8-159a6d281d1c.webp"
      },
      "poi_business_url": "https://www.mountcarmelfitness.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8882945827774254356&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mount-carmel-fitness-center",
      "poi_latitude": "40.190316",
      "poi_longitude": "-83.023457",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 740-879-4850",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019dbbbb-6172-75ca-97cf-6b43a0514b8f.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic",
        "public_id": "019dbbbb-6172-75ca-97cf-6b43a0514b8f",
        "storage_key": "property/6767906449167362/019dbbbb-6172-75ca-97cf-6b43a0514b8f.webp"
      },
      "poi_google_place_id": "ChIJW5EjCGXxOIgRFM2FnyqQRns",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_cefe9c0f-7e05-40cb-a44b-c20f1e207a20",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "poi_name": "Animal Care Unlimited",
      "poi_type": "Health and Wellness",
      "poi_address": "2665 Billingsley Rd, Columbus, OH 43235, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63ba-8d05-718b-bc5d-d754993de75e.webp",
      "poi_featured_image_media": {
        "alt_text": "Close-up of an iguana's head with a person's hand gently resting on it.",
        "public_id": "019d63ba-8d05-718b-bc5d-d754993de75e",
        "storage_key": "property/6767906449167362/019d63ba-8d05-718b-bc5d-d754993de75e.webp"
      },
      "poi_business_url": "https://www.animalcareunlimited.com/?utm_source=GMBlisting&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=1067118863813140731&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "animal-care-unlimited",
      "poi_latitude": "40.1121624",
      "poi_longitude": "-83.08634049999999",
      "poi_miles_from_property": "8.9",
      "poi_walking_minutes": "3 hours 17 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 614-766-2317",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019dbbbb-6172-75ca-97cf-6b43a0514b8f.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic",
        "public_id": "019dbbbb-6172-75ca-97cf-6b43a0514b8f",
        "storage_key": "property/6767906449167362/019dbbbb-6172-75ca-97cf-6b43a0514b8f.webp"
      },
      "poi_google_place_id": "ChIJnyXehFDtOIgR-2Cz6vMqzw4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_57cd7b0a-e973-4538-a478-fb2286f3d63e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "poi_name": "Mount Carmel St. Ann's",
      "poi_type": "Health and Wellness",
      "poi_address": "500 S Cleveland Ave, Westerville, OH 43081, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63ba-d3c8-76dc-8123-d44d2da24665.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior view of Mount Carmel St. Ann's hospital building with a welcome sign and a monument sign.",
        "public_id": "019d63ba-d3c8-76dc-8123-d44d2da24665",
        "storage_key": "property/6767906449167362/019d63ba-d3c8-76dc-8123-d44d2da24665.webp"
      },
      "poi_business_url": "https://www.mountcarmelhealth.com/location/mount-carmel-st-ann-s",
      "poi_directions_map_url": "https://maps.google.com/?cid=4415134141338069089&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mount-carmel-st-anns",
      "poi_latitude": "40.1147248",
      "poi_longitude": "-82.94613199999999",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 380-898-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019dbbbb-61c0-7798-a10b-8b9bf35dfd9e.webp",
      "poi_map_icon_media": {
        "alt_text": "H logo",
        "public_id": "019dbbbb-61c0-7798-a10b-8b9bf35dfd9e",
        "storage_key": "property/6767906449167362/019dbbbb-61c0-7798-a10b-8b9bf35dfd9e.webp"
      },
      "poi_google_place_id": "ChIJd3jOYh_1OIgRYagn8hu1RT0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_798ec29b-38ca-4246-895e-ad1ff92c6d34",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "poi_name": "Lewis Center Close To Home Center with Emergency Department",
      "poi_type": "Health and Wellness",
      "poi_address": "7853 Pacer Dr, Delaware, OH 43015, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63ba-d3b1-721b-b308-c0b5bf0cbcc4.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of a modern healthcare building with brick and stone facade.",
        "public_id": "019d63ba-d3b1-721b-b308-c0b5bf0cbcc4",
        "storage_key": "property/6767906449167362/019d63ba-d3b1-721b-b308-c0b5bf0cbcc4.webp"
      },
      "poi_business_url": "https://www.nationwidechildrens.org/locations/close-to-home-locations/lewis-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=7750986630324965995&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lewis-center-close-to-home-center-with-emergency-department",
      "poi_latitude": "40.1802782",
      "poi_longitude": "-83.024305",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 614-355-7900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019dbbbb-61c0-7798-a10b-8b9bf35dfd9e.webp",
      "poi_map_icon_media": {
        "alt_text": "H logo",
        "public_id": "019dbbbb-61c0-7798-a10b-8b9bf35dfd9e",
        "storage_key": "property/6767906449167362/019dbbbb-61c0-7798-a10b-8b9bf35dfd9e.webp"
      },
      "poi_google_place_id": "ChIJjVtV-dfzOIgRa1JSF0YJkWs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_4d2c3026-240e-41d5-99fc-923552d219a4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "poi_name": "Alum Creek State Park Beach",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3400 Lewis Center Rd, Lewis Center, OH 43035, USA",
      "poi_short_description": "3,000-ft.-long sand beach on Alum Creek Reservoir offering a swimming area, playground & showers.",
      "poi_long_description": "People say this park offers a spacious, sandy beach, clear water, and picnic spots, making it a great spot for family outings, swimming, and relaxation. They highlight the fun, lively atmosphere, and the availability of amenities like restrooms, outdoor showers, and playgrounds. They also like the ample parking and the presence of food trucks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019dbbbb-12e6-779a-938c-11d152e09869.webp",
      "poi_featured_image_media": {
        "alt_text": "Beach path alongside a lake with people enjoying the sand and water.",
        "public_id": "019dbbbb-12e6-779a-938c-11d152e09869",
        "storage_key": "property/6767906449167362/019dbbbb-12e6-779a-938c-11d152e09869.webp"
      },
      "poi_business_url": "http://parks.ohiodnr.gov/alumcreek",
      "poi_directions_map_url": "https://maps.google.com/?cid=1706347611271860685&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "alum-creek-state-park-beach",
      "poi_latitude": "40.190975",
      "poi_longitude": "-82.9707806",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 740-548-4631",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019dbbbb-615f-7798-8da3-e80b02722fc0.webp",
      "poi_map_icon_media": {
        "alt_text": "Black silhouette of a stylized Christmas tree",
        "public_id": "019dbbbb-615f-7798-8da3-e80b02722fc0",
        "storage_key": "property/6767906449167362/019dbbbb-615f-7798-8da3-e80b02722fc0.webp"
      },
      "poi_google_place_id": "ChIJr-5-IZb2OIgRzREyoRwqrhc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_97c008c6-a40d-4e82-b500-1f3c7619cf17",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "poi_name": "Highbanks Metro Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9466 Columbus Pike, Lewis Center, OH 43035, USA",
      "poi_short_description": "Native American burial grounds, 100-ft.-high bluffs with river views & 11 miles of hiking trails.",
      "poi_long_description": "People say this park offers a variety of hiking trails, scenic overlooks, and natural features, including woodlands, streams, and meadows. They highlight the family-friendly amenities, such as playgrounds, picnic areas, and a nature center with educational exhibits, as well as the well-maintained trails and clean facilities. They also like the peaceful and serene atmosphere, perfect for escaping the city and enjoying nature.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019dbbbb-140e-7152-b6e6-35f0a269c74b.webp",
      "poi_featured_image_media": {
        "alt_text": "Wooden bridge over a rocky creek in a sun-dappled forest.",
        "public_id": "019dbbbb-140e-7152-b6e6-35f0a269c74b",
        "storage_key": "property/6767906449167362/019dbbbb-140e-7152-b6e6-35f0a269c74b.webp"
      },
      "poi_business_url": "http://www.metroparks.net/parks-and-trails/highbanks/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7451794177091148460&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "highbanks-metro-park",
      "poi_latitude": "40.1541349",
      "poi_longitude": "-83.0271836",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 614-906-3149",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019dbbbb-615f-7798-8da3-e80b02722fc0.webp",
      "poi_map_icon_media": {
        "alt_text": "Black silhouette of a stylized Christmas tree",
        "public_id": "019dbbbb-615f-7798-8da3-e80b02722fc0",
        "storage_key": "property/6767906449167362/019dbbbb-615f-7798-8da3-e80b02722fc0.webp"
      },
      "poi_google_place_id": "ChIJm5B8yQDzOIgRrJrXoFIXamc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_ec7b233a-dd70-4046-8ff4-27c185d7e38d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "poi_name": "Inniswood Metro Gardens",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "940 S Hempstead Rd, Westerville, OH 43081, USA",
      "poi_short_description": "Nature preserve featuring formal gardens & lawns, a trail, with a center for workshops & a library.",
      "poi_long_description": "People say this park offers beautiful gardens, flowers, and landscaping, as well as walking paths, trails, and a tree house. They highlight the peaceful and serene atmosphere, and the opportunities for nature walks, bird watching, and meditation. They also like the well-maintained grounds and the variety of landscapes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019dbbbb-139f-77cb-bf32-7b508789c7f2.webp",
      "poi_featured_image_media": {
        "alt_text": "Beautifully manicured garden with blooming pink cherry blossom tree and lush green and red bushes.",
        "public_id": "019dbbbb-139f-77cb-bf32-7b508789c7f2",
        "storage_key": "property/6767906449167362/019dbbbb-139f-77cb-bf32-7b508789c7f2.webp"
      },
      "poi_business_url": "http://www.inniswood.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9089113309968798275&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "inniswood-metro-gardens",
      "poi_latitude": "40.1008046",
      "poi_longitude": "-82.89912679999999",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 614-895-6216",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019dbbbb-615f-7798-8da3-e80b02722fc0.webp",
      "poi_map_icon_media": {
        "alt_text": "Black silhouette of a stylized Christmas tree",
        "public_id": "019dbbbb-615f-7798-8da3-e80b02722fc0",
        "storage_key": "property/6767906449167362/019dbbbb-615f-7798-8da3-e80b02722fc0.webp"
      },
      "poi_google_place_id": "ChIJ13L2hfpfOIgRQxL3M2YEI34",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_e477a451-3cca-441a-8099-0ab88ff01894",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "poi_name": "Sharon Woods",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6911 Cleveland Ave, Westerville, OH 43081, USA",
      "poi_short_description": "Lake, jogging trails, nature walks & playground featured in 761-acre preserve with forests & fields.",
      "poi_long_description": "People say this city park offers a variety of walking paths, playgrounds, and open spaces for picnics and relaxation. They highlight the clean and well-maintained facilities, including restrooms and shelters, and the beautiful scenery with trees, fields, and a pond. They also like the peaceful and calming atmosphere, perfect for families and outdoor activities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019dbbbb-29ea-76ed-a0e6-b893add9aae8.webp",
      "poi_featured_image_media": {
        "alt_text": "Autumn trees in a park with picnic tables and covered shelters.",
        "public_id": "019dbbbb-29ea-76ed-a0e6-b893add9aae8",
        "storage_key": "property/6767906449167362/019dbbbb-29ea-76ed-a0e6-b893add9aae8.webp"
      },
      "poi_business_url": "http://www.metroparks.net/parks-and-trails/sharon-woods/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12816708023515657661&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sharon-woods",
      "poi_latitude": "40.1165707",
      "poi_longitude": "-82.96222949999999",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 614-315-5520",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019dbbbb-615f-7798-8da3-e80b02722fc0.webp",
      "poi_map_icon_media": {
        "alt_text": "Black silhouette of a stylized Christmas tree",
        "public_id": "019dbbbb-615f-7798-8da3-e80b02722fc0",
        "storage_key": "property/6767906449167362/019dbbbb-615f-7798-8da3-e80b02722fc0.webp"
      },
      "poi_google_place_id": "ChIJ7chdE-j0OIgRvbWMowoY3rE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_2f8f2eb6-0f4f-49d3-b9f2-5a3cff60adff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "poi_name": "Antrim Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5800 Olentangy River Rd, Columbus, OH 43085, USA",
      "poi_short_description": "This expansive community resource offers multiple sports fields & courts, plus walking trails.",
      "poi_long_description": "People say this park offers a scenic lake, paved trails, and opportunities for fishing, walking, running, and biking. They highlight the beautiful scenery, the fun and active vibe, and the plentiful parking. They also like the separate bike trail and the connection to the Olentangy Trail.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019dbbbb-2c51-770c-bcdc-7c28dc775556.webp",
      "poi_featured_image_media": {
        "alt_text": "Peaceful lake with trees reflecting on the water under a clear blue sky.",
        "public_id": "019dbbbb-2c51-770c-bcdc-7c28dc775556",
        "storage_key": "property/6767906449167362/019dbbbb-2c51-770c-bcdc-7c28dc775556.webp"
      },
      "poi_business_url": "https://columbusrecparks.com/parks/antrim-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8526703506149142362&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "antrim-park",
      "poi_latitude": "40.0784413",
      "poi_longitude": "-83.0376993",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 614-645-3300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019dbbbb-615f-7798-8da3-e80b02722fc0.webp",
      "poi_map_icon_media": {
        "alt_text": "Black silhouette of a stylized Christmas tree",
        "public_id": "019dbbbb-615f-7798-8da3-e80b02722fc0",
        "storage_key": "property/6767906449167362/019dbbbb-615f-7798-8da3-e80b02722fc0.webp"
      },
      "poi_google_place_id": "ChIJIcwQ2t-MOIgRWu8YlanvVHY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_50fe7c96-e4d1-4c47-8b5d-546726695750",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "poi_name": "Dinneen RC Field",
      "poi_type": "Transportation & Transit",
      "poi_address": "5770 Africa Rd, Galena, OH 43021, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63bc-85b4-7526-8a37-d44bbfc4c969.webp",
      "poi_featured_image_media": {
        "alt_text": "Remote control airplane on a grass field with a blue sky.",
        "public_id": "019d63bc-85b4-7526-8a37-d44bbfc4c969",
        "storage_key": "property/6767906449167362/019d63bc-85b4-7526-8a37-d44bbfc4c969.webp"
      },
      "poi_business_url": "http://www.wmaa-wags.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12232115923472831466&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "dinneen-rc-field",
      "poi_latitude": "40.1854146",
      "poi_longitude": "-82.95462979999999",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 614-333-3333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019dbbbb-61cc-750d-abff-f0ef9b6f13d5.webp",
      "poi_map_icon_media": {
        "alt_text": "Airplane icon",
        "public_id": "019dbbbb-61cc-750d-abff-f0ef9b6f13d5",
        "storage_key": "property/6767906449167362/019dbbbb-61cc-750d-abff-f0ef9b6f13d5.webp"
      },
      "poi_google_place_id": "ChIJh6hwN4b2OIgR6lP_tZ80wak",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airstrip"
    },
    {
      "id": "custom_bc43c54d-19e3-454c-91e4-c9add2c11ea2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "poi_name": "JPMorgan Chase McCoy Center (Chase Bank)",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1111 Polaris Pkwy, Columbus, OH 43240, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019dbbbb-4733-754f-9586-f865224b3887.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of a modern office building with large windows and manicured lawns.",
        "public_id": "019dbbbb-4733-754f-9586-f865224b3887",
        "storage_key": "property/6767906449167362/019dbbbb-4733-754f-9586-f865224b3887.webp"
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1804576629498712758&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "jpmorgan-chase-mccoy-center-chase-bank",
      "poi_latitude": "40.1401328",
      "poi_longitude": "-82.9982426",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 877-302-4273",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019dbbbb-6172-75ca-97cf-6b43a0514b8f.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic",
        "public_id": "019dbbbb-6172-75ca-97cf-6b43a0514b8f",
        "storage_key": "property/6767906449167362/019dbbbb-6172-75ca-97cf-6b43a0514b8f.webp"
      },
      "poi_google_place_id": "ChIJ6ZxwAYHzOIgRthI-K-IkCxk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_8abbd3c3-58ea-4cc9-bbde-1d1e57ca7a2f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "poi_name": "JPMC South Entrance",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Columbus, OH 43240, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=824777410602293044&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "jpmc-south-entrance",
      "poi_latitude": "40.138893",
      "poi_longitude": "-82.99728999999999",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019dbbbb-6172-75ca-97cf-6b43a0514b8f.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic",
        "public_id": "019dbbbb-6172-75ca-97cf-6b43a0514b8f",
        "storage_key": "property/6767906449167362/019dbbbb-6172-75ca-97cf-6b43a0514b8f.webp"
      },
      "poi_google_place_id": "ChIJAZ9I6IHzOIgRNFe3Ya8ycgs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_0794954d-b1ea-4dc1-a6fa-45b219fd3aee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "poi_name": "T.Marzetti Co",
      "poi_type": "Major Employers & Offices",
      "poi_address": "380 Polaris Pkwy #400, Westerville, OH 43082, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63bc-b30c-747d-8b1d-d800c74f0cfe.webp",
      "poi_featured_image_media": {
        "alt_text": "Four people in a modern meeting room with green chairs discussing a laptop.",
        "public_id": "019d63bc-b30c-747d-8b1d-d800c74f0cfe",
        "storage_key": "property/6767906449167362/019d63bc-b30c-747d-8b1d-d800c74f0cfe.webp"
      },
      "poi_business_url": "http://www.marzetti.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15421194780807184152&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tmarzetti-co",
      "poi_latitude": "40.1469439",
      "poi_longitude": "-82.9418361",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 614-846-2232",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019dbbbb-6172-75ca-97cf-6b43a0514b8f.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic",
        "public_id": "019dbbbb-6172-75ca-97cf-6b43a0514b8f",
        "storage_key": "property/6767906449167362/019dbbbb-6172-75ca-97cf-6b43a0514b8f.webp"
      },
      "poi_google_place_id": "ChIJl-PA5670OIgRGL8euvIWA9Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_3704d3ca-35c2-409f-b844-ec4f0b43d8d5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "poi_name": "J.P. Morgan Chase & Co. - 370 Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "370 Cleveland Ave, Westerville, OH 43081, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63bc-da26-76ab-bcea-5f8ad95397cf.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior view of apartment buildings under construction with portable toilets and construction vehicles.",
        "public_id": "019d63bc-da26-76ab-bcea-5f8ad95397cf",
        "storage_key": "property/6767906449167362/019d63bc-da26-76ab-bcea-5f8ad95397cf.webp"
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11686880302836206033&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "jp-morgan-chase--co---370-building",
      "poi_latitude": "40.1169701",
      "poi_longitude": "-82.94226119999999",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019dbbbb-6172-75ca-97cf-6b43a0514b8f.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic",
        "public_id": "019dbbbb-6172-75ca-97cf-6b43a0514b8f",
        "storage_key": "property/6767906449167362/019dbbbb-6172-75ca-97cf-6b43a0514b8f.webp"
      },
      "poi_google_place_id": "ChIJbRkpARn1OIgR0ckPN7cjMKI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_5e018037-6ffc-4d52-83e9-cc36a3296371",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "poi_name": "Paramount Senior Living at Polaris",
      "poi_type": "Major Employers & Offices",
      "poi_address": "702 Polaris Pkwy, Westerville, OH 43082, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.paramountseniorliving.com/paramount-communities/paramount-senior-living-at-polaris/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11036704218994658317&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "paramount-senior-living-at-polaris",
      "poi_latitude": "40.1470359",
      "poi_longitude": "-82.95376859999999",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 614-392-2079",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019dbbbb-6172-75ca-97cf-6b43a0514b8f.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic",
        "public_id": "019dbbbb-6172-75ca-97cf-6b43a0514b8f",
        "storage_key": "property/6767906449167362/019dbbbb-6172-75ca-97cf-6b43a0514b8f.webp"
      },
      "poi_google_place_id": "ChIJY5tJNNr1OIgRDUw7IANAKpk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_7e58dd20-78a3-47aa-a86e-cfea96a5d815",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_41335797-c330-485f-9a5f-b61209397e14",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_60739a04-8096-4aa4-ab54-40f9e0328314",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_46711ff8-842a-421c-81e1-5196ac009a3c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_48a0bea5-da0f-4a8f-8956-e62a85f408ef",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_67317a3b-d668-42ce-925f-0c7b72738de9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "16:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_2c4d93b7-1492-4793-85b1-101fc151da27",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "rating": "5.0",
      "name": "Alexandra Wolfe",
      "text": "I enjoyed my time at Pierpoint! Tina and Matthew in the leasing office were always kind and helpful with any questions. Renting/moving process was easy. Maintenance was prompt responding to service requests. If we needed to move our cars for work in the parking lots we were given ample notice and information. Cute apartment and in a great location!",
      "date": "2024-11-05",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_12a3db851bf389fe20861f6f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "Virtual Tour 1",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://vapi.apartments.com/video/play/KlgrvWxpFqC?source=180"
    },
    {
      "id": "ec_517c0fbf8251f8c7678ee39a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "LoopNet Video",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://vapi.apartments.com/video/play/4q6w0v?source=180"
    },
    {
      "id": "ec_82213d29b08b80c0ccce7ebe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "Virtual Tour 3",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://vapi.apartments.com/video/play/8q6k2h?source=180"
    },
    {
      "id": "ec_152c8a13e5637fb5e82ce641",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63ba-f98b-704a-81d2-e0e57056ac1c.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d63ba-f98b-704a-81d2-e0e57056ac1c",
        "storage_key": "property/6767906449167362/019d63ba-f98b-704a-81d2-e0e57056ac1c.webp"
      },
      "virtual_tour_title": "Clubroom",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=an119gosSqU"
    },
    {
      "id": "ec_a9217ca8e09cead26ccb8c32",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019ed97a-ce33-71a2-bce8-a922831ad7e9.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ed97a-ce33-71a2-bce8-a922831ad7e9",
        "storage_key": "property/6767906449167362/019ed97a-ce33-71a2-bce8-a922831ad7e9.webp"
      },
      "virtual_tour_title": "1BR, 1BA - 600SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=UKdhPLTHowo"
    },
    {
      "id": "ec_db7835061c018dee4199504e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63ba-f9be-745c-aa58-72874e19703d.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d63ba-f9be-745c-aa58-72874e19703d",
        "storage_key": "property/6767906449167362/019d63ba-f9be-745c-aa58-72874e19703d.webp"
      },
      "virtual_tour_title": "1BR, 1BA - 600 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=U2NeRBKUqNM"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019e1ddc-85c6-7414-bbbf-de31bb5a1890",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "pie---pierpont",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362"
    },
    {
      "lead_collector_id": "019e1ddc-8634-7048-9da8-60bd8ad15616",
      "lead_source": "FACEBOOK_ADS",
      "name": "pie---pierpont",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362"
    },
    {
      "lead_collector_id": "019e1ddc-86a4-71c8-8691-e187591023da",
      "lead_source": "LANDING_PAGE",
      "name": "pie---pierpont",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "page_item_url": "pet-friendly-apartments-westerville-oh",
      "search_query": "pet friendly apartments Westerville OH",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments in Westerville, OH",
      "h2_subtitle": "Discover pet-friendly living in Westerville, OH. Pierpont offers welcoming spaces for you and your furry friends.",
      "page_copy": "Welcome to Pierpont, your destination for pet-friendly apartments in Westerville, OH. Here, you and your furry friends will find a warm and inviting home. Our community is designed to cater to the needs of all residents, including your pets, ensuring you both can enjoy luxurious amenities.\n\nLocated in the serene Far North neighborhood, Pierpont offers one- and two-bedroom apartments with all the comforts and conveniences you desire. You and your pet will enjoy features like central heat and air conditioning, modern kitchens with dishwashers, and in-unit washers and dryers. Plus, our fitness center and sparkling pool invite both relaxation and recreation. Come experience Pierpont today, where pet-friendly living meets exceptional comfort.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63bb-e4f3-77ac-9d12-3491e87f0fb7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a multifamily apartment complex with multiple buildings, a pool, and surrounding greenery.",
        "public_id": "019d63bb-e4f3-77ac-9d12-3491e87f0fb7",
        "storage_key": "property/6767906449167362/019d63bb-e4f3-77ac-9d12-3491e87f0fb7.webp"
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments Westerville, OH",
      "seo_description": "Discover Pierpont's pet-friendly apartments in Westerville, OH. Perfect living spaces for you and your pet with top-notch amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "page_item_url": "apartments-with-pool-far-north",
      "search_query": "apartments with a pool in Far North",
      "category": "Amenity",
      "h1_title": "Apartments with a Pool in Far North",
      "h2_subtitle": "Live in comfort and style at Pierpont, offering apartments with a pool in the Far North neighborhood.",
      "page_copy": "Dive into relaxation at Pierpont, where our apartments with a pool in the Far North neighborhood await you. Our sparkling swimming pool provides the perfect spot to unwind after a long day or enjoy a sunny afternoon with friends.\n\nIn addition to the pool, our Far North location offers stylish one- and two-bedroom apartment homes equipped with modern amenities such as central heat and air conditioning, a fully-equipped kitchen complete with a dishwasher, and in-home washers and dryers. Our fitness center is available for those who prefer keeping active indoors. Discover the blend of comfort and leisure living in Pierpont's community today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63bb-e4f3-77ac-9d12-3491e87f0fb7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a multifamily apartment complex with multiple buildings, a pool, and surrounding greenery.",
        "public_id": "019d63bb-e4f3-77ac-9d12-3491e87f0fb7",
        "storage_key": "property/6767906449167362/019d63bb-e4f3-77ac-9d12-3491e87f0fb7.webp"
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool, Far North",
      "seo_description": "Explore Pierpont's apartments with a pool in Far North, offering a blend of comfort and style in a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "page_item_url": "fitness-center-apartments-franklin-county",
      "search_query": "fitness center apartments Franklin County",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments in Franklin County",
      "h2_subtitle": "Stay fit at Pierpont, offering apartments with a fitness center in Franklin County. Enjoy luxurious living.",
      "page_copy": "Experience the perfect blend of comfort and fitness at Pierpont, where our apartments with a fitness center in Franklin County are designed to meet your lifestyle needs. Our state-of-the-art fitness center ensures you have convenient access to workout facilities right at your doorstep.\n\nLocated in the vibrant Far North neighborhood, Pierpont offers spacious one- and two-bedroom apartments featuring modern comforts such as central heat and air conditioning, premium kitchens with dishwashers, and full-size washers and dryers. In addition to the fitness center, residents can enjoy our sparkling pool and pet-friendly spaces. Make Pierpont your home and embrace an active, convenient lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63bb-e4f3-77ac-9d12-3491e87f0fb7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a multifamily apartment complex with multiple buildings, a pool, and surrounding greenery.",
        "public_id": "019d63bb-e4f3-77ac-9d12-3491e87f0fb7",
        "storage_key": "property/6767906449167362/019d63bb-e4f3-77ac-9d12-3491e87f0fb7.webp"
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments Franklin County",
      "seo_description": "Discover Pierpont's fitness center apartments in Franklin County, offering modern amenities and a convenient lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "page_item_url": "air-conditioned-apartments-westerville",
      "search_query": "air conditioned apartments Westerville",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments in Westerville",
      "h2_subtitle": "Enjoy cool comfort at Pierpont, where air-conditioned apartments in Westerville create a perfect home environment.",
      "page_copy": "Stay comfortable year-round at Pierpont, featuring air-conditioned apartments in Westerville. Our homes are equipped with central heating and air conditioning, ensuring optimal comfort no matter the season.\n\nLocated in the peaceful Far North neighborhood, Pierpont offers a variety of one- and two-bedroom layouts with modern finishes. Each apartment boasts convenient features like in-unit washers and dryers, dishwashers, and stylish window coverings. Beyond the comfort of your home, enjoy our community amenities, including a sparkling pool and a fully-equipped fitness center. Experience the best of cooled comfort and neighborhood charm at Pierpont.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63bb-e4f3-77ac-9d12-3491e87f0fb7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a multifamily apartment complex with multiple buildings, a pool, and surrounding greenery.",
        "public_id": "019d63bb-e4f3-77ac-9d12-3491e87f0fb7",
        "storage_key": "property/6767906449167362/019d63bb-e4f3-77ac-9d12-3491e87f0fb7.webp"
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments Westerville",
      "seo_description": "Pierpont offers air-conditioned apartments in Westerville with modern amenities for a comfortable living experience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "page_item_url": "apartments-in-unit-laundry-43081",
      "search_query": "apartments with in-unit laundry 43081",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry in 43081",
      "h2_subtitle": "Discover the convenience of in-unit laundry at Pierpont, offering modern apartments in Westerville's 43081 area.",
      "page_copy": "At Pierpont, we understand the value of convenience, which is why our apartments with in-unit laundry in the 43081 area are perfect for easy living. Enjoy the luxury of having a full-size washer and dryer in your own home, eliminating the hassle of communal laundry facilities.\n\nNestled in Westerville's desirable Far North neighborhood, Pierpont provides a selection of stylish one- and two-bedroom apartments. Each residence is thoughtfully designed with features such as central heating and air conditioning and modern kitchens that include dishwashers. Beyond your doorstep, indulge in community amenities like our sparkling swimming pool and state-of-the-art fitness center. Discover comfortable living made easy at Pierpont.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63bb-e4f3-77ac-9d12-3491e87f0fb7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a multifamily apartment complex with multiple buildings, a pool, and surrounding greenery.",
        "public_id": "019d63bb-e4f3-77ac-9d12-3491e87f0fb7",
        "storage_key": "property/6767906449167362/019d63bb-e4f3-77ac-9d12-3491e87f0fb7.webp"
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with In-Unit Laundry 43081",
      "seo_description": "Explore Pierpont's convenient apartments with in-unit laundry in Westerville's 43081 area, offering modern amenities for stress-free living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-westerville-oh",
      "search_query": "one bedroom apartments westerville oh",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Westerville, OH",
      "h2_subtitle": "Explore Pierpont's one bedroom apartments in Westerville, OH. Ideal for comfort and convenience.",
      "page_copy": "Discover the ideal one bedroom apartments in Westerville, OH at Pierpont. Our thoughtfully designed units combine style and functionality to create the perfect home environment. Spacious layouts and modern amenities provide the perfect setting for a comfortable lifestyle.\n\nSituated in the vibrant Far North neighborhood, Pierpont offers residents a host of community features, including a sparkling swimming pool and a fitness center. Inside, enjoy the convenience of central heating and air conditioning, a dishwasher, and an in-unit washer and dryer. Experience the perfect mix of modern living and community charm at Pierpont, where comfort meets convenience in every one bedroom apartment.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63bb-e4f3-77ac-9d12-3491e87f0fb7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a multifamily apartment complex with multiple buildings, a pool, and surrounding greenery.",
        "public_id": "019d63bb-e4f3-77ac-9d12-3491e87f0fb7",
        "storage_key": "property/6767906449167362/019d63bb-e4f3-77ac-9d12-3491e87f0fb7.webp"
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments Westerville, OH",
      "seo_description": "Find your new home in Pierpont's one bedroom apartments in Westerville, OH, offering modern amenities and comfortable living spaces.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-far-north-franklin-county",
      "search_query": "two bedroom apartments far north franklin county",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Far North Franklin",
      "h2_subtitle": "Discover spacious two bedroom apartments in Far North, Franklin County at Pierpont, blending convenience and style.",
      "page_copy": "Looking for two bedroom apartments in Far North, Franklin County? Pierpont offers spacious and stylish options perfect for any lifestyle. Our two-bedroom layouts provide ample space with modern touches, ensuring you enjoy both comfort and functionality.\n\nLocated in the serene Far North neighborhood of Westerville, our community features amenities that enhance your living experience, including a fitness center and sparkling pool. Each apartment comes complete with central heating and air conditioning, dishwashers, and in-unit laundry facilities. Experience the blend of spacious living and modern amenities at Pierpont, making it the ideal choice for two bedroom living in Franklin County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63bb-e4f3-77ac-9d12-3491e87f0fb7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a multifamily apartment complex with multiple buildings, a pool, and surrounding greenery.",
        "public_id": "019d63bb-e4f3-77ac-9d12-3491e87f0fb7",
        "storage_key": "property/6767906449167362/019d63bb-e4f3-77ac-9d12-3491e87f0fb7.webp"
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Far North Franklin",
      "seo_description": "Explore Pierpont's spacious two bedroom apartments in Far North, Franklin County, offering modern amenities for a comfortable lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "page_item_url": "apartments-near-worthington-christian-school-westerville",
      "search_query": "apartments near Worthington Christian School Westerville",
      "category": "School",
      "h1_title": "Apartments Near Worthington Christian School",
      "h2_subtitle": "Find the perfect home near Worthington Christian School. Pierpont offers convenient apartment living in Westerville.",
      "page_copy": "Located just a short distance from Worthington Christian School, Pierpont presents an ideal living option in Westerville. Our community offers one and two-bedroom apartments designed for modern comfort and convenience.\n\nResidents can enjoy a variety of top-notch amenities, including a sparkling pool, fitness center, and pet-friendly spaces. Each apartment includes central heating, air conditioning, and in-unit laundry, making everyday life easy and enjoyable. Choose Pierpont for a home that connects you with the best Westerville has to offer, educationally and leisurely, while keeping you conveniently close to Worthington Christian School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63bb-e4f3-77ac-9d12-3491e87f0fb7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a multifamily apartment complex with multiple buildings, a pool, and surrounding greenery.",
        "public_id": "019d63bb-e4f3-77ac-9d12-3491e87f0fb7",
        "storage_key": "property/6767906449167362/019d63bb-e4f3-77ac-9d12-3491e87f0fb7.webp"
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Worthington Christian School",
      "seo_description": "Explore Pierpont's convenient apartments in Westerville, near Worthington Christian School, with modern amenities and an ideal location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "page_item_url": "westerville-oh-apartments-near-worthington-park-elementary",
      "search_query": "Westerville OH apartments close to Worthington Park Elementary School",
      "category": "School",
      "h1_title": "Westerville Apartments Near Worthington Park Elem",
      "h2_subtitle": "Discover prime living at Pierpont, close to Worthington Park Elementary School in Westerville, OH.",
      "page_copy": "Pierpont offers exceptional apartment living in Westerville, OH, conveniently located near Worthington Park Elementary School. Our one and two-bedroom apartments are spacious and designed for comfortable living.\n\nEnjoy a host of community amenities, including a sparkling pool and fitness center, while each apartment provides modern conveniences like in-unit laundry, central heating, and air conditioning. Experience the blend of comfort, style, and location at Pierpont, making it a top choice for those seeking easy access to schools and a vibrant community atmosphere in Westerville.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63bb-e4f3-77ac-9d12-3491e87f0fb7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a multifamily apartment complex with multiple buildings, a pool, and surrounding greenery.",
        "public_id": "019d63bb-e4f3-77ac-9d12-3491e87f0fb7",
        "storage_key": "property/6767906449167362/019d63bb-e4f3-77ac-9d12-3491e87f0fb7.webp"
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Westerville OH Apartments Near Worthington Park",
      "seo_description": "Find Westerville, OH apartments at Pierpont close to Worthington Park Elementary, offering modern amenities in a top location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "page_item_url": "far-north-apartments-near-slate-hill-elementary",
      "search_query": "Far North neighborhood apartments near Slate Hill Elementary School",
      "category": "School",
      "h1_title": "Far North Apartments Near Slate Hill School",
      "h2_subtitle": "Explore Pierpont's welcoming community in the Far North neighborhood, close to Slate Hill Elementary School.",
      "page_copy": "Located in the desirable Far North neighborhood, Pierpont offers exceptional living options just a short drive from Slate Hill Elementary School. Our one and two-bedroom apartments feature modern amenities that make day-to-day living a breeze.\n\nResidents enjoy access to a fitness center, refreshing pool, and pet-friendly areas, while each apartment is equipped with conveniences such as in-unit laundry, air conditioning, and more. Choose Pierpont and make the most of a peaceful yet connected lifestyle in the Far North neighborhood, with easy access to educational institutions like Slate Hill Elementary School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63bb-e4f3-77ac-9d12-3491e87f0fb7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a multifamily apartment complex with multiple buildings, a pool, and surrounding greenery.",
        "public_id": "019d63bb-e4f3-77ac-9d12-3491e87f0fb7",
        "storage_key": "property/6767906449167362/019d63bb-e4f3-77ac-9d12-3491e87f0fb7.webp"
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Far North Apartments Near Slate Hill Elementary",
      "seo_description": "Discover Pierpont's Far North neighborhood apartments near Slate Hill Elementary, offering a connected lifestyle with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "page_item_url": "westerville-apartments-near-worthingway-middle-school",
      "search_query": "Westerville apartments close to Worthingway Middle School",
      "category": "School",
      "h1_title": "Westerville Apartments Near Worthingway School",
      "h2_subtitle": "Live conveniently at Pierpont in Westerville, close to Worthingway Middle School.",
      "page_copy": "Pierpont provides an ideal living environment in Westerville, just moments away from Worthingway Middle School. \n\nWith exceptional community features like a fitness center, swimming pool, and pet-friendly spaces, Pierpont ensures residents enjoy the best of comfort and convenience. Each apartment includes modern necessities such as in-unit laundry and central heating and air conditioning. Experience the perfect balance of location and lifestyle by choosing Pierpont, where quality living and education go hand in hand in Westerville.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63bb-e4f3-77ac-9d12-3491e87f0fb7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a multifamily apartment complex with multiple buildings, a pool, and surrounding greenery.",
        "public_id": "019d63bb-e4f3-77ac-9d12-3491e87f0fb7",
        "storage_key": "property/6767906449167362/019d63bb-e4f3-77ac-9d12-3491e87f0fb7.webp"
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Westerville Apartments Near Worthingway Middle School",
      "seo_description": "Find modern Westerville apartments at Pierpont near Worthingway Middle School, offering convenient living with excellent amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "page_item_url": "franklin-county-apartments-near-thomas-worthington-high",
      "search_query": "Franklin County OH apartments near Thomas Worthington High School",
      "category": "School",
      "h1_title": "Franklin County Apartments Near Worthington High",
      "h2_subtitle": "Discover Pierpont's prime location, offering Franklin County, OH apartments near Thomas Worthington High School.",
      "page_copy": "Pierpont presents modern apartment living in Franklin County, OH, conveniently near Thomas Worthington High School. \n\nResidents enjoy amenities such as a fitness center, pool, and pet-friendly areas, while each apartment is equipped with essential features like in-unit laundry, central heating, and air conditioning. Make Pierpont your home and benefit from a community that combines accessibility, comfort, and convenience near Thomas Worthington High School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63bb-e4f3-77ac-9d12-3491e87f0fb7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a multifamily apartment complex with multiple buildings, a pool, and surrounding greenery.",
        "public_id": "019d63bb-e4f3-77ac-9d12-3491e87f0fb7",
        "storage_key": "property/6767906449167362/019d63bb-e4f3-77ac-9d12-3491e87f0fb7.webp"
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Franklin County Apartments Near Thomas Worthington High",
      "seo_description": "Explore Pierpont's Franklin County, OH apartments near Thomas Worthington High School, offering quality living with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "page_item_url": "apartments-near-otterbein-university-westerville",
      "search_query": "apartments near Otterbein University Westerville",
      "category": "School",
      "h1_title": "Apartments Near Otterbein University",
      "h2_subtitle": "Discover convenient living at Pierpont, offering stylish apartments near Otterbein University in Westerville.",
      "page_copy": "Pierpont caters to those seeking modern apartment living conveniently near Otterbein University in Westerville. Our one and two-bedroom apartments are designed for anyone desiring proximity to this notable educational institution.\n\nEnjoy top-notch amenities such as a fitness center, swimming pool, and pet-friendly spaces, making daily living comfortable and enjoyable. Each apartment features vital conveniences, including a dishwasher, central heating and air conditioning, and in-unit laundry. Choose Pierpont for a seamless blend of convenience and style, right near Otterbein University.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63bb-e4f3-77ac-9d12-3491e87f0fb7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a multifamily apartment complex with multiple buildings, a pool, and surrounding greenery.",
        "public_id": "019d63bb-e4f3-77ac-9d12-3491e87f0fb7",
        "storage_key": "property/6767906449167362/019d63bb-e4f3-77ac-9d12-3491e87f0fb7.webp"
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Otterbein University, Westerville",
      "seo_description": "Live at Pierpont in Westerville near Otterbein University. Enjoy modern apartments with top amenities today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "page_item_url": "apartments-near-alum-creek-park-north-westerville",
      "search_query": "apartments near Alum Creek Park North Westerville",
      "category": "Park",
      "h1_title": "Apartments Near Alum Creek Park North",
      "h2_subtitle": "Experience Pierpont, offering prime apartments near Alum Creek Park North in Westerville.",
      "page_copy": "Discover the ideal living experience at Pierpont, offering stylish apartments just steps from Alum Creek Park North in Westerville. Perfect for nature lovers and those who enjoy outdoor activities, Pierpont provides convenient access to expansive green spaces and scenic trails.\n\nResidents benefit from modern amenities, including a fitness center, sparkling pool, and pet-friendly areas. Inside each apartment, enjoy conveniences such as a dishwasher, washer/dryer, and central heating and air conditioning. Choose Pierpont, where comfort meets nature near the beautiful Alum Creek Park North.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63bb-e4f3-77ac-9d12-3491e87f0fb7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a multifamily apartment complex with multiple buildings, a pool, and surrounding greenery.",
        "public_id": "019d63bb-e4f3-77ac-9d12-3491e87f0fb7",
        "storage_key": "property/6767906449167362/019d63bb-e4f3-77ac-9d12-3491e87f0fb7.webp"
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Alum Creek Park North, Westerville",
      "seo_description": "Discover stylish living at Pierpont, with apartments near Alum Creek Park North, Westerville, offering modern amenities and easy access to nature.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "page_item_url": "pierpont-apartments-close-alum-creek-park-south",
      "search_query": "Pierpont apartments close to Alum Creek Park South",
      "category": "Park",
      "h1_title": "Pierpont Apartments Near Alum Creek Park South",
      "h2_subtitle": "Explore Pierpont, featuring apartments close to Alum Creek Park South, offering a blend of style and nature.",
      "page_copy": "At Pierpont, enjoy modern living with apartments that are conveniently close to Alum Creek Park South. This location is perfect for those who love outdoor activities and the beauty of natural surroundings.\n\nWhether you desire a vibrant day at the park or comfort at home, Pierpont has you covered with amenities like a fitness center, sparkling pool, and pet-friendly spaces. Apartments are equipped with necessary features like a washer/dryer, dishwasher, and central heat and air conditioning. Embrace a lifestyle of convenience and tranquility at Pierpont, situated near the lovely Alum Creek Park South.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63bb-e4f3-77ac-9d12-3491e87f0fb7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a multifamily apartment complex with multiple buildings, a pool, and surrounding greenery.",
        "public_id": "019d63bb-e4f3-77ac-9d12-3491e87f0fb7",
        "storage_key": "property/6767906449167362/019d63bb-e4f3-77ac-9d12-3491e87f0fb7.webp"
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pierpont Apartments by Alum Creek Park South",
      "seo_description": "Discover Pierpont's convenient location, with modern apartments close to Alum Creek Park South. Enjoy amenities and a serene setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "page_item_url": "heritage-park-nearby-westerville-oh-apartments",
      "search_query": "Heritage Park nearby Westerville OH apartments",
      "category": "Park",
      "h1_title": "Apartments Near Heritage Park, Westerville OH",
      "h2_subtitle": "Find your perfect home at Pierpont, offering Westerville OH apartments near Heritage Park.",
      "page_copy": "Pierpont presents an ideal living option with its Westerville OH apartments, located conveniently near Heritage Park. Enjoy easy access to this scenic area known for its trails, recreational areas, and top environment.\n\nOur communities offer modern amenities such as a fitness center, swimming pool, and cozy pet-friendly areas. Each apartment features thoughtful amenities like central heating and air, a convenient dishwasher, and an in-unit washer/dryer. Choose Pierpont for your new home, where comfort and nature blend perfectly near Heritage Park in Westerville.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63bb-e4f3-77ac-9d12-3491e87f0fb7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a multifamily apartment complex with multiple buildings, a pool, and surrounding greenery.",
        "public_id": "019d63bb-e4f3-77ac-9d12-3491e87f0fb7",
        "storage_key": "property/6767906449167362/019d63bb-e4f3-77ac-9d12-3491e87f0fb7.webp"
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Westerville OH Apartments Near Heritage Park",
      "seo_description": "Live at Pierpont, offering apartments near Heritage Park in Westerville OH. Enjoy modern living with convenient amenities and park access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "page_item_url": "huber-village-park-near-apartments-43081",
      "search_query": "Huber Village Park near apartments in 43081",
      "category": "Park",
      "h1_title": "Apartments Near Huber Village Park, 43081",
      "h2_subtitle": "Discover Pierpont with its perfect location near Huber Village Park in the 43081 area, offering you modern living and natural beauty.",
      "page_copy": "At Pierpont, experience the best of both worlds with our modern apartments located in the 43081 area near Huber Village Park. This prime location offers quick access to lush green spaces and recreational fun, making it an ideal choice for outdoor enthusiasts.\n\nOur community features luxury amenities such as a fitness center, a refreshing pool, and pet-friendly spaces, enhancing your living experience. Inside, each apartment is equipped with central heat and air conditioning, a washer/dryer, and a dishwasher for extra convenience. Choose Pierpont for a balance of comfort and nature, just minutes from Huber Village Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63bb-e4f3-77ac-9d12-3491e87f0fb7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a multifamily apartment complex with multiple buildings, a pool, and surrounding greenery.",
        "public_id": "019d63bb-e4f3-77ac-9d12-3491e87f0fb7",
        "storage_key": "property/6767906449167362/019d63bb-e4f3-77ac-9d12-3491e87f0fb7.webp"
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "43081 Apartments Near Huber Village Park",
      "seo_description": "Explore Pierpont apartments in 43081, near Huber Village Park. Enjoy modern living with great amenities and close park access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "page_item_url": "hoff-woods-park-surrounds-westerville-oh-living",
      "search_query": "Hoff Woods Park surrounds Westerville OH living",
      "category": "Park",
      "h1_title": "Westerville OH Living Near Hoff Woods Park",
      "h2_subtitle": "Experience the charm of Pierpont, where Westerville OH living is beautifully surrounded by Hoff Woods Park.",
      "page_copy": "Enjoy the vibrant lifestyle of Westerville OH, surrounded by the natural beauty of Hoff Woods Park. Pierpont offers a perfect escape with its proximity to the park, combining tranquility with modern convenience.\n\nOur community includes amenities like a state-of-the-art fitness center, a dazzling pool, and comfortable pet-friendly areas. Each apartment is crafted with convenience in mind, featuring a dishwasher, in-unit washer/dryer, and central heating and air. Living at Pierpont means embracing a lifestyle enriched by the lush landscapes of Hoff Woods Park, ideal for those seeking peace and connectivity.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63bb-e4f3-77ac-9d12-3491e87f0fb7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a multifamily apartment complex with multiple buildings, a pool, and surrounding greenery.",
        "public_id": "019d63bb-e4f3-77ac-9d12-3491e87f0fb7",
        "storage_key": "property/6767906449167362/019d63bb-e4f3-77ac-9d12-3491e87f0fb7.webp"
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Westerville Living by Hoff Woods Park",
      "seo_description": "Discover Pierpont, where living in Westerville OH is enhanced by the proximity to Hoff Woods Park. Modern amenities meet natural beauty.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "page_item_url": "paul-s-metzger-park-franklin-county-apartment-living",
      "search_query": "Paul S. Metzger Park Franklin County apartment living",
      "category": "Park",
      "h1_title": "Apartment Living Near Paul S. Metzger Park",
      "h2_subtitle": "Explore Pierpont's exceptional Franklin County apartment living near Paul S. Metzger Park, merging comfort with nature.",
      "page_copy": "Pierpont's location in Franklin County offers residents a chance to enjoy apartment living near the serene Paul S. Metzger Park. Whether you're looking to stroll through the park's scenic trails or enjoy tranquil green spaces, this is the perfect place to call home.\n\nOur apartments are designed for modern living and convenience, featuring central heat and air, a dishwasher, and an in-unit washer/dryer. Residents can also enjoy community amenities like a fitness center and a sparkling pool. Choose Pierpont for a lifestyle where Paul S. Metzger Park enhances your everyday living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63bb-e4f3-77ac-9d12-3491e87f0fb7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a multifamily apartment complex with multiple buildings, a pool, and surrounding greenery.",
        "public_id": "019d63bb-e4f3-77ac-9d12-3491e87f0fb7",
        "storage_key": "property/6767906449167362/019d63bb-e4f3-77ac-9d12-3491e87f0fb7.webp"
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Franklin County Apartments by Metzger Park",
      "seo_description": "Live at Pierpont in Franklin County, where apartment living is enhanced by the proximity to Paul S. Metzger Park and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "page_item_url": "millstone-creek-park-accessibility-pierpont-apartments",
      "search_query": "Millstone Creek Park accessibility from Pierpont apartments",
      "category": "Park",
      "h1_title": "Easy Access to Millstone Creek Park",
      "h2_subtitle": "Explore the convenience of living at Pierpont, where Millstone Creek Park is easily accessible, enhancing your lifestyle with nature.",
      "page_copy": "Pierpont Apartments offer residents a harmonious blend of urban living and natural beauty, with easy accessibility to Millstone Creek Park. Just a short distance away, this park provides a nature-filled escape with walking trails and open spaces.\n\nPierpont is designed with modern amenities to cater to your lifestyle, featuring a fitness center, pet-friendly areas, and a pool to unwind in. Inside your apartment, enjoy the comforts of central heating, air conditioning, a dishwasher, and in-unit laundry. Embrace a lifestyle where the beauty of Millstone Creek Park is just moments away.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63bb-e4f3-77ac-9d12-3491e87f0fb7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a multifamily apartment complex with multiple buildings, a pool, and surrounding greenery.",
        "public_id": "019d63bb-e4f3-77ac-9d12-3491e87f0fb7",
        "storage_key": "property/6767906449167362/019d63bb-e4f3-77ac-9d12-3491e87f0fb7.webp"
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pierpont Apartments Near Millstone Creek Park",
      "seo_description": "Discover Pierpont Apartments offering easy access to Millstone Creek Park. Enjoy modern amenities and the beauty of nearby natural spaces.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "page_item_url": "olde-town-park-close-westerville-apartments",
      "search_query": "Olde Town Park close to Westerville apartments",
      "category": "Park",
      "h1_title": "Westerville Apartments Near Olde Town Park",
      "h2_subtitle": "Live at Pierpont, where Westerville apartments offer proximity to Olde Town Park, enriching your days with green spaces nearby.",
      "page_copy": "Experience the ideal blend of city life and nature at Pierpont, located just a stone's throw away from Westerville's charming Olde Town Park. This proximity provides residents with easy access to serene walking paths and lush green spaces, perfect for relaxation and recreation.\n\nPierpont apartments feature window coverings, central heating and air conditioning, and in-unit washers and dryers. Enjoy community living with amenities such as a fitness center, a sparkling pool, and spaces designed for pets. Embrace a lifestyle that combines modern comforts with the serene backdrop of Olde Town Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63bb-e4f3-77ac-9d12-3491e87f0fb7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a multifamily apartment complex with multiple buildings, a pool, and surrounding greenery.",
        "public_id": "019d63bb-e4f3-77ac-9d12-3491e87f0fb7",
        "storage_key": "property/6767906449167362/019d63bb-e4f3-77ac-9d12-3491e87f0fb7.webp"
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Westerville Living Close to Olde Town Park",
      "seo_description": "Choose Pierpont for Westerville apartments with access to Olde Town Park. Enjoy a balanced lifestyle with modern amenities and nearby green spaces.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167362",
      "source": "custom",
      "page_item_url": "hoover-reservoir-parkland-far-north-ohio-apartments",
      "search_query": "Hoover Reservoir Parkland near Far North Ohio apartments",
      "category": "Park",
      "h1_title": "Far North Apartments by Hoover Reservoir Parkland",
      "h2_subtitle": "Discover the convenience of living in Far North Ohio apartments with easy access to the scenic Hoover Reservoir Parkland.",
      "page_copy": "Pierpont offers a prime location in Far North Ohio, where residents can enjoy easy access to the beautiful Hoover Reservoir Parkland. Perfect for outdoor enthusiasts, the parkland provides ample opportunities for hiking, picnicking, and enjoying water views.\n\nOur apartments are thoughtfully designed, offering central heat and air conditioning, window coverings, and modern amenities like a dishwasher and in-unit laundry. Residents can also take advantage of our fitness center, pool, and pet-friendly spaces. Live close to nature while enjoying the modern comforts of Pierpont apartments near Hoover Reservoir Parkland.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167362/019d63bb-e4f3-77ac-9d12-3491e87f0fb7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a multifamily apartment complex with multiple buildings, a pool, and surrounding greenery.",
        "public_id": "019d63bb-e4f3-77ac-9d12-3491e87f0fb7",
        "storage_key": "property/6767906449167362/019d63bb-e4f3-77ac-9d12-3491e87f0fb7.webp"
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Far North Apartments Near Hoover Reservoir Parkland",
      "seo_description": "Live at Pierpont in Far North Ohio, offering easy access to Hoover Reservoir Parkland. Enjoy nature and modern amenities in your new home.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "6184"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11680139486"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4962893"
    },
    {
      "ID": "custom_adtaxi_domain",
      "type": "STRING",
      "value": "https://tags.tiqcdn.com/utag/adtaxi/pierpontliving.com/prod/utag.js"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-KHTXTN64"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 1"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Preferred"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "1c9d1afa5011ed51"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "c0c85c72a64e11edbd41023423a61a29"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "614-810-8261"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IkVHTjlRb1dlTkRLMHEyOEE2S2JCaVE9PSIsInZhbHVlIjoiQWthYkhjR3NpaE90cHRrUUFWME12Zz09IiwibWFjIjoiZWQzNTNiODFkODEzNDU3MjMzNGY2NDk1N2NmNWQzYzliZTcyNzA2OGZhYmYxMDc0OTlmZDEzNWYxOWExODUwYiJ9"
    }
  ],
  "custom_qb_id": "6184",
  "custom_repli_id": "11680139486",
  "custom_realpage_id": "4962893",
  "custom_adtaxi_domain": "https://tags.tiqcdn.com/utag/adtaxi/pierpontliving.com/prod/utag.js",
  "custom_google_gtm_id": "GTM-KHTXTN64",
  "custom_rollout_phase": "Phase 1",
  "custom_vibesites_theme": "Preferred",
  "custom_knock_community_id": "1c9d1afa5011ed51",
  "custom_knock_company_token": "c0c85c72a64e11edbd41023423a61a29",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_ppc_tracking_phone_number": "614-810-8261",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IkVHTjlRb1dlTkRLMHEyOEE2S2JCaVE9PSIsInZhbHVlIjoiQWthYkhjR3NpaE90cHRrUUFWME12Zz09IiwibWFjIjoiZWQzNTNiODFkODEzNDU3MjMzNGY2NDk1N2NmNWQzYzliZTcyNzA2OGZhYmYxMDc0OTlmZDEzNWYxOWExODUwYiJ9",
  "custom_audioeye_site_id": "9f5ac31c-5f24-4cdb-a1fc-66610bdea59d",
  "custom_audioeye_site_hash": "d84069799b2a93353b7ef50aae396ca0"
};

export const generatedAt = '2026-08-12T21:07:50.302Z';
